// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:05:53.574Z
// Property: Springhouse Townhomes (ID: 6767906449166344)
// Collections: 24 amenities, 6 floorplans (live), 17 photos, 80 POIs, 3 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166344",
  "property_external_id": "4993353",
  "property_zillow_url": "https://www.zillow.com/apartments/allentown-pa/springhouse-townhomes/Ckn9HX/",
  "property_apartments_url": "https://www.apartments.com/springhouse-townhomes-allentown-pa/jyem0e5/",
  "property_google_business_url": "https://www.google.com/maps/place/Springhouse+Townhomes/data=!4m2!3m1!1s0x0:0x954af1ca9ad6fe5f?sa=X&ved=2ahUKEwiyrcSd5riSAxUf_skDHT6JI0MQ_BJ6BAgUEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "springhouse-townhomes",
  "property_name": "Springhouse Townhomes",
  "property_website_url": "https://www.springhousetownhomes.com/",
  "property_domain": "https://www.springhousetownhomes.com/",
  "property_address": "3701-3725 Allen Street",
  "property_full_address": "3701 Allen St, Allentown, PA 18104",
  "property_address_1": "3701 Allen St",
  "property_address_2": null,
  "property_address_city": "Allentown",
  "property_address_state": "PA",
  "property_address_zip_full": "18104",
  "property_address_zip": "18104",
  "property_address_country": "US",
  "property_address_county": "Lehigh County",
  "property_neighborhood_address": "West End-Allentown",
  "property_address_latitude": "40.5920442",
  "property_address_longitude": "-75.5394975",
  "property_email": "springhouse@aionmanagement.com",
  "property_phone": "(610) 867-7100",
  "property_call_tracking_phone": "888-820-5340",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Springhouse Townhomes in Allentown, PA, spacious three and two-bedroom designs offer a blend of modern comfort and convenience. Enjoy scenic views, upgraded kitchens with granite countertops, and pet-friendly amenities like grilling stations and walking trails. Embrace a vibrant lifestyle—your stylish home awaits!",
  "property_long_description": "Welcome to Springhouse Townhomes, your idyllic retreat in Allentown, PA, where luxury meets comfort! Our thoughtfully designed community offers a variety of spacious floor plans, including two and three-bedroom apartments, each featuring modern amenities and stunning views. \n\nExplore lush walking and biking trails right at your doorstep, or unwind with friends at our inviting grilling stations. Enjoy the convenience of our online resident portal for easy rent payments and maintenance requests, while our dedicated on-site management and 24-hour emergency maintenance ensure that you feel right at home. \n\nPet lovers will appreciate our pet-friendly policies, while residents can take advantage of the flexible short-term lease options available. Each apartment boasts upgraded features, such as sleek granite countertops, stainless steel appliances, and beautiful vaulted ceilings that create an open and airy atmosphere. Enjoy upgraded kitchen designs, spacious closets, and select homes that offer private balconies with serene courtyard, pond, or river views.\n\nRelax and recharge in either our cozy townhomes or opt for a penthouse suite that showcases breathtaking panoramas. With air conditioning, high-speed internet availability, and garages that cater to your parking needs, we are committed to elevating your living experience. \n\nSpringhouse Townhomes combines style, convenience, and community living in the heart of Allentown. Don’t miss the chance to make this exceptional community your new home! Find your new home today by browsing our availability or scheduling a tour to visit us in person!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-258c-76ca-b9a4-c559ee15596b.webp",
  "property_featured_image_media": {
    "alt_text": "Gazebo and picnic tables in front of apartment buildings",
    "public_id": "019fce09-258c-76ca-b9a4-c559ee15596b",
    "storage_key": "property/6767906449166344/019fce09-258c-76ca-b9a4-c559ee15596b.webp",
    "width": 1920,
    "height": 1282
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "34",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "All animals must be housebroken; no breeding allowed. Breed restrictions apply: German Shepherds, Akitas, Chow Terriers or Chow mixes, American Bulldogs, Bull Staff/Staffordshire Terriers, Dobermans (mini pinschers are permitted), Rottweilers, Wolf‑dog hybrids, Pit‑bull terriers, Presa Canario or Canary dogs (50% or more mix by veterinary report). Maximum of 2 pets per unit. No weight restrictions.",
  "property_pet_policy_description": "We welcome dogs, cats, and service animals. All animals must be housebroken; no breeding allowed. Breed restrictions apply: German Shepherds, Akitas, Chow Terriers or Chow mixes, American Bulldogs, Bull Staff/Staffordshire Terriers, Dobermans (mini pinschers are permitted), Rottweilers, Wolf‑dog hybrids, Pit‑bull terriers, Presa Canario or Canary dogs (50% or more mix by veterinary report). Pet fee: $300 one‑time for one pet, $350 for two pets. Monthly pet rent: $50 for one pet, $75 for two pets. Maximum of 2 pets per unit. No weight restrictions.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://springhousetownhomes.loftliving.com/login",
  "property_apply_now_url": "https://www.springhousetownhomes.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-7bae-74aa-9ce1-1640ec229dd8.webp",
  "property_primary_logo_media": {
    "alt_text": "HS monogram logo on a dark background.",
    "public_id": "019d026a-7bae-74aa-9ce1-1640ec229dd8",
    "storage_key": "property/6767906449166344/019d026a-7bae-74aa-9ce1-1640ec229dd8.webp",
    "width": 1650,
    "height": 1275
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026c-688a-73cd-b429-0ab5a2cc179f.webp",
  "property_secondary_logo_media": {
    "alt_text": "AI ON MANAGEMENT logo",
    "public_id": "019d026c-688a-73cd-b429-0ab5a2cc179f",
    "storage_key": "property/6767906449166344/019d026c-688a-73cd-b429-0ab5a2cc179f.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026c-77bd-70cd-b677-bfee14a3bb77.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Springhouse Townhome Rentals logo.",
    "public_id": "019d026c-77bd-70cd-b677-bfee14a3bb77",
    "storage_key": "property/6767906449166344/019d026c-77bd-70cd-b677-bfee14a3bb77.webp",
    "width": 640,
    "height": 495
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026c-8381-761b-90d0-2b84d32c4d2f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Springhouse Townhome Rentals logo",
    "public_id": "019d026c-8381-761b-90d0-2b84d32c4d2f",
    "storage_key": "property/6767906449166344/019d026c-8381-761b-90d0-2b84d32c4d2f.webp",
    "width": 640,
    "height": 495
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2.5",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1584 - 2964",
  "property_sqft_min": "1584",
  "property_sqft_max": "2964",
  "property_price_range": "2728 - 3564",
  "property_price_min": "2728",
  "property_price_max": "3564",
  "property_available_units": null,
  "property_facebook_url": "https://www.facebook.com/springhousetownhomes",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJQ92FYNAxxIkRX_7WmsrxSpU",
  "property_youtube_url": "https://www.youtube.com/watch?t=143&v=kcqnWVlrkr4",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Things+to+Do&find_near=steve-slaski-crosscountry-mortgage-allentown",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Springhouse Townhomes",
  "property_home_romance_title": "Unlock the Door to Your Perfect Apartment Sanctuary",
  "property_home_amenities_blurb": "Welcome to Springhouse Townhomes in Allentown, PA, where modern living meets comfort. Choose from spacious two and three-bedroom designs, savor delightful amenities like walking trails, high-speed internet, and grilling stations. Enjoy the ease of our online resident portal while basking in the beauty of lush views from your private balcony.",
  "property_home_floorplans_blurb": "Nestled in the heart of Allentown, Springhouse Townhomes offers spacious floor plans, including inviting three-bedroom and cozy two-bedroom options. Each layout is designed for comfort and style. Browse our available apartment homes to find your ideal space and elevate your living experience today!",
  "property_home_gallery_blurb": "At Springhouse Townhomes in Allentown, PA, modern living meets serene comfort. Choose from spacious two and three-bedroom layouts complete with upgraded kitchens, vaulted ceilings, and a pet-friendly atmosphere. Enjoy walking trails, grilling stations, and 24-hour maintenance for hassle-free living. Picture yourself thriving in this vibrant community!",
  "property_home_neighborhood_blurb": "Welcome to Springhouse Townhomes in Allentown, PA, where modern living meets vibrant surroundings. Nestled among cultural gems like the Allentown Art Museum and the Civic Theatre, our community offers spacious two- and three-bedroom floor plans, plus quick access to parks, schools, and major transit hubs. Dive into local favorites!",
  "property_home_reviews_blurb": "At Springhouse Townhomes in Allentown, PA, residents rave about their vibrant home experience, praising it as “a perfect blend of comfort and community.” Immerse yourself in a neighborhood where relationships flourish and amenities delight. Ready to feel at home? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Springhouse Townhomes, life unfolds in a vibrant neighborhood! Immerse yourself in local culture at Civic Theatre of Allentown or enjoy nature at Trexler Memorial Park. With easy access to top schools and Lehigh Valley International Airport, convenience is at your doorstep. Uncover the charm of Allentown and beyond!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Springhouse Townhomes in Allentown, PA, luxury meets comfort. Enjoy spacious floor plans ranging from cozy two-bedroom layouts to expansive three-bedroom townhomes. Revel in our pet-friendly community with walking trails, grilling stations, and modern conveniences like high-speed internet and on-site management—all designed for your comfort and lifestyle.",
  "property_applynow_blurb": "Embrace life at Springhouse Townhomes in Allentown, PA, where modern living meets nature's beauty. Choose from spacious floor plans featuring gourmet kitchens and vaulted ceilings. Enjoy pet-friendly amenities, scenic walking trails, and convenient online leasing. Your ideal home awaits—step into a lifestyle designed just for you! ",
  "property_contactus_blurb": "At Springhouse Townhomes in Allentown, PA, find your perfect fit with our thoughtfully designed floor plans, including spacious two and three-bedroom options. Whether you desire a cozy retreat or ample living space, we’re here to help! Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Springhouse Townhomes in Allentown, PA, our spacious three- and two-bedroom floor plans cater to every lifestyle. Curious about amenities, pet policies, or lease terms? Visit our FAQs page to uncover everything you need to know about calling Springhouse home. Your ideal living experience starts with informed choices!",
  "property_floorplans_blurb": "At Springhouse Townhomes in Allentown, PA, your ideal living space awaits. With thoughtfully designed three and two-bedroom floor plans, each home seamlessly blends comfort and style. Unveil the potential of your new lifestyle—navigate through our available options and find the perfect layout that suits your needs.",
  "property_gallery_blurb": "Immerse yourself in the vibrant lifestyle at Springhouse Townhomes in Allentown, PA. Our spacious three and two-bedroom layouts feature modern finishes like granite countertops and stainless steel appliances. Enjoy scenic walking trails, pet-friendly amenities, and cozy corners perfect for grilling. Picture yourself relaxing in our serene courtyard or upgraded townhomes!",
  "property_interactivemap_blurb": "At Springhouse Townhomes in Allentown, PA, your ideal living space awaits. Choose from spacious two and three-bedroom floor plans featuring modern amenities like stainless steel appliances, vaulted ceilings, and picturesque pond views. Utilize our interactive community map to seamlessly find your new home and embrace a lifestyle of comfort and convenience.",
  "property_pets_blurb": "At Springhouse Townhomes in Allentown, PA, your furry companions can enjoy a welcoming community designed for both comfort and companionship. With space for up to two pets, we ensure a harmonious lifestyle while observing breed guidelines. Join us for a pet-friendly living experience that feels like home!",
  "property_referafriend_blurb": "At Springhouse Townhomes in Allentown, PA, spacious living meets vibrant community life. Choose from our beautifully designed two and three-bedroom floor plans, perfect for sharing great moments with friends. Great friends make great neighbors—refer a friend to our welcoming community today and experience the joy of living together!",
  "property_residentaccess_blurb": "At Springhouse Townhomes in Allentown, PA, our inviting three and two-bedroom residences blend comfort with style. Elevate your living experience—access your resident portal today to effortlessly pay rent, schedule maintenance, and manage your home needs. Your seamless lifestyle awaits!",
  "property_reviews_blurb": "At Springhouse Townhomes in Allentown, PA, our residents rave about the vibrant community spirit and spacious living spaces. One happy resident exclaims, “The staff here truly feels like family!” Dive into our reviews to see why so many call Springhouse home! Your new lifestyle awaits!",
  "property_created_at": "1757011493976",
  "property_scheduletour_blurb": "At Springhouse Townhomes in Allentown, PA, you'll find spacious three and two-bedroom layouts designed for modern living. Experience a vibrant community that harmonizes comfort and convenience. Ready to see your future home? Schedule a tour today and hear from our delighted residents about their experiences in our welcoming neighborhood!",
  "property_thankyou_blurb": "Thank you for reaching out! At Springhouse Townhomes in Allentown, PA, we offer spacious floor plans, including two and three-bedroom layouts tailored for your lifestyle. Embrace comfort and community living—our team will be in touch soon to help you find your perfect home. Your journey to relaxation starts here!",
  "property_virtualtours_blurb": "Step into your dream home at Springhouse Townhomes in Allentown, PA! We offer spacious two- and three-bedroom floor plans designed for modern living. Ready to envision your new lifestyle? Take a virtual tour today and uncover the perfect blend of comfort and convenience waiting for you!",
  "property_copyright": "2025 All Rights Reserved. Springhouse Townhomes",
  "property_seo_title_home": "Springhouse Townhomes |  Apartments in Allentown, PA",
  "property_seo_description_home": "Experience modern living at Springhouse Townhomes in Allentown! Enjoy spacious layouts, pet-friendly amenities, and scenic views. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Allentown, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Springhouse Townhomes in Allentown, PA! Our stylish three and two-bedroom floor plans offer comfort and style. Browse today!",
  "property_seo_title_amenities": "Amenities | Allentown, PA Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Springhouse Townhomes in Allentown! Enjoy spacious, pet-friendly living with great amenities like trails and grilling stations.",
  "property_seo_title_gallery": "Gallery | Apartments in Allentown, PA",
  "property_seo_description_gallery": "Picture your life at Springhouse Townhomes in Allentown, PA! Enjoy stunning views, modern amenities, and a vibrant community. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Springhouse Townhomes Apartments",
  "property_seo_description_virtualtours": "Discover Springhouse Townhomes in Allentown, PA! Explore our spacious two and three-bedroom layouts with a virtual tour of your future home!",
  "property_seo_title_interactivemap": "Interactive Map | Springhouse Townhomes Apartments",
  "property_seo_description_interactivemap": "Unwind at Springhouse Townhomes in Allentown! Enjoy spacious layouts, resort-style amenities, and scenic walking trails. Explore your ideal apartment!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Allentown, PA",
  "property_seo_description_neighborhood": "Find your ideal home at Springhouse Townhomes in Allentown, PA! Uncover local favorites and nearby attractions that make our neighborhood vibrant and inviting.",
  "property_seo_title_contact": "Contact Us | Springhouse Townhomes",
  "property_seo_description_contact": "Reach out to the friendly leasing team at Springhouse Townhomes in Allentown, PA. Your perfect 2 or 3-bedroom home awaits—let's chat!",
  "property_seo_title_faqs": "FAQs | Apartments in Allentown, PA",
  "property_seo_description_faqs": "Unlock a world of comfort at Springhouse Townhomes in Allentown, PA! Our FAQs page answers all your queries about pet-friendly living and modern amenities.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Allentown, PA",
  "property_seo_description_reviews": "Discover vibrant Springhouse Townhomes in Allentown! Explore resident reviews for insights on spacious layouts, pet-friendly perks, and more!",
  "property_seo_title_applynow": "Apply Now | Apartments in Allentown, PA",
  "property_seo_description_applynow": "Discover comfort at Springhouse Townhomes, Allentown! Enjoy spacious layouts, stunning views, pet-friendly amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Springhouse Townhomes",
  "property_seo_description_residentaccess": "Unlock convenience at Springhouse Townhomes! Log in to easily pay rent, schedule maintenance, and manage your home in Allentown, PA. Your comfort awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Springhouse Townhomes",
  "property_seo_description_referafriend": "Refer a friend to Springhouse Townhomes in Allentown, PA! Great friends make the best neighbors—share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Springhouse Townhomes",
  "property_seo_description_scheduletour": "Uncover the charm of Springhouse Townhomes in Allentown, PA! Ready to find your new home? Schedule a tour today and experience comfort like never before!",
  "property_seo_title_privacy": "Privacy Policy | Springhouse Townhomes",
  "property_seo_description_privacy": "At Springhouse Townhomes in Allentown, PA, your privacy matters. Read our policy to learn how we protect your personal information. Your peace of mind awaits!",
  "property_seo_title_accessibility": "Website Accessibility | Springhouse Townhomes",
  "property_seo_description_accessibility": "At Springhouse Townhomes in Allentown, PA, we prioritize accessibility for all. Join our inclusive community where everyone feels at home!",
  "property_seo_title_sitemap": "Sitemap | Springhouse Townhomes",
  "property_seo_description_sitemap": "Navigate your way to comfort at Springhouse Townhomes in Allentown, PA. Check out our sitemap for a seamless look at our community offerings!",
  "property_seo_title_thankyou": "Thank You | Springhouse Townhomes",
  "property_seo_description_thankyou": "Thank you for reaching out to Springhouse Townhomes! Our team will connect with you soon to help you find your perfect Allentown home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Allentown, PA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293569394",
  "amenities": [
    {
      "id": "custom_53ba9866-de15-49b9-84c0-34d97cb37048",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2a3216e0-ebd2-4669-9390-454ac6514c9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1feaf60f-9206-4109-a936-893914a2d10b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5d6e90f3-d972-46df-838e-642073997964",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8eb8e20c-8e0d-40a3-aef7-1e29f6ecce5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88340cf5-7a95-4a8c-ab64-bbfd7bc33605",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61bca4e1-3186-4efd-a602-b36ef6d9e82b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Attached Garages",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbc18e03-cfb1-4b1d-8fdf-c7d48a91f209",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Basement",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d13e50e3-e387-4292-963b-d0e76df76117",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a88cd268-8551-409f-8cd0-fc4e260a0094",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81fa8bc2-fa8a-4b85-a93c-688ff0d10cd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2fae2414-c95c-4cd4-9ef6-553a9bee882e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91eda0e4-007e-4da3-aea9-149b178c9c10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5021ccdd-c309-4b3b-bdae-18a171f07b70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_241a8797-327d-45ee-ad2e-15aa039b8924",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Private Driveway",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2460423d-e5d1-4aa0-a7f2-a68e8a3fa59a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Under-Cabinet Lighting",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77d0df95-2285-4b22-b897-4ce466636913",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_348941bd-acf5-48b6-8b54-1ea5f07f4c8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f74ff5c-a988-4b63-8207-8f634ee44f43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_10e6a18b-c373-4a5c-95f5-3de058642aa3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes to Trexler Memorial Park",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4bdd255e-aa44-48d1-9694-c543ac4e6c01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Walking & Biking Trails",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_09521e87-8bea-44c7-86d7-0cc7d73db96f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d7d372c-3bb7-4627-9a45-35d82a4e515b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e84ff10e-70d7-44bd-ace5-d19c8de944cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "external_id": "false",
      "title": "Security System",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_77a1bc9e-5697-4786-b370-67a66e667ff5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-4a6b-751e-93de-48617983ef03.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, a gas stove, refrigerator, and a large sink.",
        "public_id": "019fce09-4a6b-751e-93de-48617983ef03",
        "storage_key": "property/6767906449166344/019fce09-4a6b-751e-93de-48617983ef03.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample white cabinetry, a full suite of appliances including a gas range and refrigerator, and a double-basin sink. Perfect for home chefs.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, a gas stove, refrigerator, and a large sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/Springhouse_2026_DSC_8449_03-02-26_15_06.jpg"
    },
    {
      "id": "custom_47fff6cf-a8fe-493e-8e14-dea4848782af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-4a6f-700a-84d1-9d0bcb6ff60e.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with vaulted ceilings, a large TV, and a comfortable bed.",
        "public_id": "019fce09-4a6f-700a-84d1-9d0bcb6ff60e",
        "storage_key": "property/6767906449166344/019fce09-4a6f-700a-84d1-9d0bcb6ff60e.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Bright modern apartment bedroom featuring a king-size bed, dresser, wall TV, and double closet doors.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, dresser, wall-mounted TV, and double closet doors at Springhouse Townhomes in Allentown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/10c1b11ed3025b872d4aa5e2909d7955-c1dfbedc.webp"
    },
    {
      "id": "custom_64b864fa-008a-405a-b235-feefbaee760d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-4a39-708e-955f-03f8ae23a9d5.webp",
      "image_media": {
        "alt_text": "Spacious living room with a gray sectional sofa, fireplace, and large arched windows.",
        "public_id": "019fce09-4a39-708e-955f-03f8ae23a9d5",
        "storage_key": "property/6767906449166344/019fce09-4a39-708e-955f-03f8ae23a9d5.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed living room, featuring a cozy fireplace and abundant natural light streaming through large arched windows.",
      "link": "false",
      "alt_text": "Spacious living room with a gray sectional sofa, fireplace, and large arched windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/Springhouse_2026_DSC_8487_03-02-26_15_40.jpeg"
    },
    {
      "id": "custom_d7d802c9-8ecb-4de0-8838-75e0ab704c4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-4a80-7049-b710-30515051c579.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, dining area, and open kitchen.",
        "public_id": "019fce09-4a80-7049-b710-30515051c579",
        "storage_key": "property/6767906449166344/019fce09-4a80-7049-b710-30515051c579.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Enjoy ample space in this open-concept living area, featuring a comfortable sectional sofa, a dedicated dining space, and a modern kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a sectional sofa, dining area, and open kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/Springhouse_2026_DSC_8506_03-02-26_16_30.jpeg"
    },
    {
      "id": "custom_2bad5ad9-93d3-4b98-bc96-c018fcd6b7e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-54d6-71a0-9284-262dd2632d19.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table and chairs, adjacent to a living room with a fireplace.",
        "public_id": "019fce09-54d6-71a0-9284-262dd2632d19",
        "storage_key": "property/6767906449166344/019fce09-54d6-71a0-9284-262dd2632d19.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Elegant dining area with a comfortable seating arrangement, perfect for family meals and entertaining guests. The space flows seamlessly into a cozy living room with a fireplace.",
      "link": "false",
      "alt_text": "Dining area with a wooden table and chairs, adjacent to a living room with a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/Springhouse_2026_DSC_8479_03-02-26_15_58.jpeg"
    },
    {
      "id": "custom_fbd1b53f-0bf4-4b4b-9a49-06112feaaebd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-5665-728a-be8f-b4a162d63928.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-sized bed, nightstands, and a desk area with a computer.",
        "public_id": "019fce09-5665-728a-be8f-b4a162d63928",
        "storage_key": "property/6767906449166344/019fce09-5665-728a-be8f-b4a162d63928.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "A well-appointed bedroom featuring a king-sized bed, stylish nightstands, and a dedicated workspace with a desk and computer, perfect for relaxation and productivity.",
      "link": "false",
      "alt_text": "Spacious bedroom with a king-sized bed, nightstands, and a desk area with a computer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/Springhouse_2026_DSC_8575_03-02-26_15_43.jpeg"
    },
    {
      "id": "custom_e5830044-b10a-446e-b153-812353c52c2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-5652-7044-b2ae-bd1cafcb676b.webp",
      "image_media": {
        "alt_text": "Attic bedroom with a skylight, desk, and computer.",
        "public_id": "019fce09-5652-7044-b2ae-bd1cafcb676b",
        "storage_key": "property/6767906449166344/019fce09-5652-7044-b2ae-bd1cafcb676b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Cozy attic bedroom with a skylight, perfect for a home office or a quiet retreat. Features a modern desk and a comfortable seating area.",
      "link": "false",
      "alt_text": "Attic bedroom with a skylight, desk, and computer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/Springhouse_2026_DSC_8580_03-02-26_16_11.jpeg"
    },
    {
      "id": "custom_5d3c504a-d452-41f1-bded-af495edbee5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-5714-764d-8e98-8e110c96ac23.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and mounted TV.",
        "public_id": "019fce09-5714-764d-8e98-8e110c96ac23",
        "storage_key": "property/6767906449166344/019fce09-5714-764d-8e98-8e110c96ac23.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Contemporary apartment bedroom with neutral tones and modern decor for a comfortable retreat.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a large bed, two nightstands, a dresser, and a wall-mounted TV at Springhouse Townhomes in Allentown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/5767906449162442/6767906449166344/be05eb94f39a56c689945fdd7feb2918.webp"
    },
    {
      "id": "custom_1b03e75b-3f93-43a1-88b1-413acaba7f6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-5f3d-76ed-98b4-e08b48b2a2bc.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a large bed, closet, and mounted TV.",
        "public_id": "019fce09-5f3d-76ed-98b4-e08b48b2a2bc",
        "storage_key": "property/6767906449166344/019fce09-5f3d-76ed-98b4-e08b48b2a2bc.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Neutral, modern bedroom featuring a bed, gray walls, a double-door closet, and a TV console.",
      "link": "false",
      "alt_text": "Bedroom with a neatly made bed, gray walls, double closet doors, and a TV on a wooden dresser at Springhouse Townhomes in Allentown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/5767906449162442/6767906449166344/e3430978a5768134b4518399d6c27eae.jpg"
    },
    {
      "id": "custom_042db4c8-a24a-4b64-9e16-9c4c994f93f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-62ee-756d-92a9-65e59f981fbf.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower/tub combination.",
        "public_id": "019fce09-62ee-756d-92a9-65e59f981fbf",
        "storage_key": "property/6767906449166344/019fce09-62ee-756d-92a9-65e59f981fbf.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and comfort of this beautifully appointed apartment bathroom, featuring a sleek vanity, a clean toilet, and a spacious shower/tub combo.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower/tub combination.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/Springhouse_2026_DSC_8563_03-02-26_16_09.jpeg"
    },
    {
      "id": "custom_df8ad7cc-b416-4487-89e4-c8de6b50c330",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-63bf-75af-99d6-eed01e3d0240.webp",
      "image_media": {
        "alt_text": "Balcony with seating area overlooking trees and green space.",
        "public_id": "019fce09-63bf-75af-99d6-eed01e3d0240",
        "storage_key": "property/6767906449166344/019fce09-63bf-75af-99d6-eed01e3d0240.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drink on your private balcony, offering serene views of the surrounding greenery.",
      "link": "false",
      "alt_text": "Balcony with cushioned wicker seating, a small round table, a hanging fern, and a view of a green lawn at Springhouse Townhomes in Allentown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/5767906449162442/6767906449166344/c7b498feb805de332d6177ca8d57de4e.webp"
    },
    {
      "id": "custom_e38886c6-c6ae-4a48-a725-d2569941cf9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6366-73ea-b1be-c0a335204220.webp",
      "image_media": {
        "alt_text": "Interior view of an empty garage with an open door showing a residential street.",
        "public_id": "019fce09-6366-73ea-b1be-c0a335204220",
        "storage_key": "property/6767906449166344/019fce09-6366-73ea-b1be-c0a335204220.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious and clean garage with an open door, providing direct access to the exterior and a glimpse of the surrounding neighborhood.",
      "link": "false",
      "alt_text": "Interior view of an empty garage with an open door showing a residential street.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/Springhouse_Townhomes_DSC_8592_03-02-26_14_02.jpg"
    },
    {
      "id": "custom_6e36e874-deb4-4b95-b7ab-781a1ad7318f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6a48-7356-b75d-a0a00dd44acf.webp",
      "image_media": {
        "alt_text": "Townhouses with garages and manicured landscaping under a blue sky.",
        "public_id": "019fce09-6a48-7356-b75d-a0a00dd44acf",
        "storage_key": "property/6767906449166344/019fce09-6a48-7356-b75d-a0a00dd44acf.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Exterior of a modern townhouse-style apartment community with attached garages and manicured landscaping.",
      "link": "false",
      "alt_text": "Exterior view of a townhouse-style apartment building with attached garages and landscaping at Springhouse Townhomes in Allentown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/5767906449162442/6767906449166344/18d907de1f77da33bfd51ef7bd0952ba.webp"
    },
    {
      "id": "custom_7c53210e-ac95-463f-b4ef-de68e7ad5bf7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f21-730d-a4f5-929a04667ffb.webp",
      "image_media": {
        "alt_text": "Aerial view of a residential community with townhouses and lush landscaping.",
        "public_id": "019fce09-6f21-730d-a4f5-929a04667ffb",
        "storage_key": "property/6767906449166344/019fce09-6f21-730d-a4f5-929a04667ffb.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Experience comfortable living in this beautiful residential community featuring charming townhomes surrounded by manicured lawns and mature trees.",
      "link": "false",
      "alt_text": "Aerial view of a suburban apartment community with white buildings, circular drive, and central gazebo at Springhouse Townhomes in Allentown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/5767906449162442/6767906449166344/82790240d0baedcff0a4f04415d63328.webp"
    },
    {
      "id": "custom_3320cdf6-7ebd-40eb-92da-b216a3ec9c8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Bird's-eye view of a modern apartment community with attached garages, manicured landscaping, and a large parking lot near a shopping center.",
      "link": "false",
      "alt_text": "Aerial view of a suburban apartment community with white townhomes, garages, and a large parking lot at Springhouse Townhomes in Allentown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/eac583a00cf8e641f79e094cb317ae04-2f5e871c.webp"
    },
    {
      "id": "custom_155a0671-f877-4f99-ab97-66400559b8d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-7283-72a9-823d-be8ca1de0281.webp",
      "image_media": {
        "alt_text": "Gazebo and picnic tables in front of apartment buildings with a bright blue sky and white clouds.",
        "public_id": "019fce09-7283-72a9-823d-be8ca1de0281",
        "storage_key": "property/6767906449166344/019fce09-7283-72a9-823d-be8ca1de0281.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy the outdoors at our community picnic areas and gazebo, perfect for relaxing or gathering with friends and neighbors.",
      "link": "false",
      "alt_text": "White gazebo in a landscaped apartment community courtyard at Springhouse Townhomes in Allentown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/5767906449162442/6767906449166344/5e98d9c86d08187304e6292c8543348b.webp"
    },
    {
      "id": "custom_50101205-1cc9-4495-b7a6-201eb1da5564",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-795a-77aa-a094-61beb4184b07.webp",
      "image_media": {
        "alt_text": "Gazebo and picnic tables in a landscaped community area with residential buildings in the background.",
        "public_id": "019fce09-795a-77aa-a094-61beb4184b07",
        "storage_key": "property/6767906449166344/019fce09-795a-77aa-a094-61beb4184b07.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Outdoor community amenity featuring a gazebo, walking paths, and lush landscaping at the apartment complex.",
      "link": "false",
      "alt_text": "Gazebo in a landscaped apartment complex courtyard with trees and benches at Springhouse Townhomes in Allentown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/69bc94aa/dms3rep/multi/5767906449162442/6767906449166344/e485f9fdb73717dcfcddfbadaa0af8a8.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_bc9a918b-e226-495c-8ef1-66d94c12955b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "The Udder Bar",
      "poi_type": "Restaurants",
      "poi_address": "1852 W Allen St, Allentown, PA 18104, USA",
      "poi_short_description": "Family-run parlor for housemade ice cream, plus liege waffles, bubble waffles, and edible cookie dough.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b11d-72a4-b012-db03fd385b68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-b11d-72a4-b012-db03fd385b68",
        "storage_key": "property/6767906449166344/019fce09-b11d-72a4-b012-db03fd385b68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theudderbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14310733423270444659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-udder-bar",
      "poi_latitude": "40.6035453",
      "poi_longitude": "-75.4999599",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 484-221-8653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqWjlFYo5xIkRcz5YGTrwmcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_693ae1e3-b4fb-47e3-9ed8-2394ddf3d7e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Henry's Salt of the Sea",
      "poi_type": "Restaurants",
      "poi_address": "1926 W Allen St, Allentown, PA 18104, USA",
      "poi_short_description": "Quaint, French-inspired seafood restaurant with a full bar also offering steak & chicken entrees.",
      "poi_long_description": "Quaint, French-inspired seafood restaurant with a full bar also offering steak & chicken entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-afd9-7106-bbfa-eb77e3dac0c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-afd9-7106-bbfa-eb77e3dac0c2",
        "storage_key": "property/6767906449166344/019fce09-afd9-7106-bbfa-eb77e3dac0c2.webp",
        "width": 533,
        "height": 400
      },
      "poi_business_url": "http://www.henryssaltofthesea.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5797435337053926858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henrys-salt-of-the-sea",
      "poi_latitude": "40.603356",
      "poi_longitude": "-75.5012675",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-434-2628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2WAh4o5xIkRynVlEbmgdFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_04abbd35-095e-4c07-810f-ae8806322340",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Salvatore Ruffino's",
      "poi_type": "Restaurants",
      "poi_address": "1902 W Allen St, Allentown, PA 18104, USA",
      "poi_short_description": "Easygoing eatery dishing up thin-crust pies, stromboli and hot sandwiches, plus pasta and chicken dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b0ff-771c-bf2e-d4018b327204.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-b0ff-771c-bf2e-d4018b327204",
        "storage_key": "property/6767906449166344/019fce09-b0ff-771c-bf2e-d4018b327204.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.salvatoreruffinos.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16312518087169793994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salvatore-ruffinos",
      "poi_latitude": "40.6035561",
      "poi_longitude": "-75.50040589999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-437-3621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJheoIboo5xIkRyt_j2cW0YeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e862d1e2-a827-4575-a579-c18503210489",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Sleepy Cat Urban Winery",
      "poi_type": "Restaurants",
      "poi_address": "1840 W Allen St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b11d-72a4-b012-d47f4d04a761.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-b11d-72a4-b012-d47f4d04a761",
        "storage_key": "property/6767906449166344/019fce09-b11d-72a4-b012-d47f4d04a761.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sleepycaturbanwinery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3207473504000088598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sleepy-cat-urban-winery",
      "poi_latitude": "40.6035766",
      "poi_longitude": "-75.4997947",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-351-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSSOPYo5xIkRFhpncCg8gyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_918e7210-7bdc-4385-98c8-c345adf27545",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Ringers Roost",
      "poi_type": "Restaurants",
      "poi_address": "1801 Liberty St, Allentown, PA 18104, USA",
      "poi_short_description": "Bar & grill offering a diverse American menu in a relaxed setting with sports-centric decor.",
      "poi_long_description": "Bar & grill offering a diverse American menu in a relaxed setting with sports-centric decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b641-75b2-9b7f-813c168aad52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-b641-75b2-9b7f-813c168aad52",
        "storage_key": "property/6767906449166344/019fce09-b641-75b2-9b7f-813c168aad52.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://ringersroostpa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13733602758227834359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ringers-roost",
      "poi_latitude": "40.6031706",
      "poi_longitude": "-75.4979026",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-437-4941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-68650771c87e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-68650771c87e",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-68650771c87e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjyt65Yk5xIkR97V-4vGOl74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b3821a8c-c089-45ff-ab6d-36de5a43edfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Syb's West End Deli",
      "poi_type": "Restaurants",
      "poi_address": "2151 Liberty St, Allentown, PA 18104, USA",
      "poi_short_description": "Cozy local haunt for deli eats, plus staples for brekkie, sandwiches and omelets during the day.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b7cc-7039-ae2b-d27b3a6e6473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-b7cc-7039-ae2b-d27b3a6e6473",
        "storage_key": "property/6767906449166344/019fce09-b7cc-7039-ae2b-d27b3a6e6473.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/sybsdeli/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8746624154757109151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sybs-west-end-deli",
      "poi_latitude": "40.6008362",
      "poi_longitude": "-75.5059627",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-434-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-67fb-7148-bfd3-a69641545faa",
        "storage_key": "property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVsgCx86xIkRnxUmwFNAYnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_adfa0464-397b-44c1-80a2-ee1b1f86aee1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Tavern on Liberty",
      "poi_type": "Restaurants",
      "poi_address": "2246 Liberty St, Allentown, PA 18104, USA",
      "poi_short_description": "Easygoing standby featuring pub grub & an extensive craft beer selection in bottles & on tap.",
      "poi_long_description": "Easygoing standby featuring pub grub & an extensive craft beer selection in bottles & on tap.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b785-72ae-a0ad-7999ab0f5fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-b785-72ae-a0ad-7999ab0f5fdc",
        "storage_key": "property/6767906449166344/019fce09-b785-72ae-a0ad-7999ab0f5fdc.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.thelibertytaproom.com/the-tavern-on-liberty-about",
      "poi_directions_map_url": "https://maps.google.com/?cid=5323965909916154976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tavern-on-liberty",
      "poi_latitude": "40.600062",
      "poi_longitude": "-75.5078041",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 484-221-8765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-68650771c87e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-68650771c87e",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-68650771c87e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmxLA5h46xIkRYHzXmMmG4kk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a8b52f11-0920-48da-bb43-9651d90bf0b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Youell's Oyster House",
      "poi_type": "Restaurants",
      "poi_address": "2249 Walnut St, Allentown, PA 18104, USA",
      "poi_short_description": "Veteran eatery offering its seafood menu in a remodeled space that includes a rooftop garden.",
      "poi_long_description": "Veteran eatery offering its seafood menu in a remodeled space that includes a rooftop garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b91e-7265-a8ca-f375f84bbdd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-b91e-7265-a8ca-f375f84bbdd1",
        "storage_key": "property/6767906449166344/019fce09-b91e-7265-a8ca-f375f84bbdd1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://youellsoysterhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14649594416034595799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "youells-oyster-house",
      "poi_latitude": "40.591908",
      "poi_longitude": "-75.5040362",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-439-1203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJYP2Zj06xIkR18NJJ4HQTcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_35b9f3d6-8cc7-4d69-866a-6cf63cfdc763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Union & Finch",
      "poi_type": "Restaurants",
      "poi_address": "1528 Union St, Allentown, PA 18102, USA",
      "poi_short_description": "Bright, cozy setting for seasonal American bistro fare amid wood-heavy decor & an old-fashioned bar.",
      "poi_long_description": "Bright, cozy setting for seasonal American bistro fare amid wood-heavy decor & an old-fashioned bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-bc95-75a8-83c0-e1b660f5b78c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-bc95-75a8-83c0-e1b660f5b78c",
        "storage_key": "property/6767906449166344/019fce09-bc95-75a8-83c0-e1b660f5b78c.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "http://www.unionandfinch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15425894913673620205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union--finch",
      "poi_latitude": "40.5947951",
      "poi_longitude": "-75.4876562",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-432-1522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6_HVly46xIkR7WoFsLHJE9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b692c804-3480-4353-a895-e9abe3674219",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Tacos Y Tequila Allentown",
      "poi_type": "Restaurants",
      "poi_address": "530 Hamilton St, Allentown, PA 18101, USA",
      "poi_short_description": "Casual, kid-friendly restaurant featuring Mexican dishes such as street tacos, plus craft beer, and live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-bed5-76e9-9ac2-d069e2cea056.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-bed5-76e9-9ac2-d069e2cea056",
        "storage_key": "property/6767906449166344/019fce09-bed5-76e9-9ac2-d069e2cea056.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tacosytequilaallentown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6577696262577618850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacos-y-tequila-allentown",
      "poi_latitude": "40.6028126",
      "poi_longitude": "-75.4690657",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 610-351-8226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Sbak_05xIkRon9ak-arSFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_da0e8ef7-4d56-4400-a11f-9b6e38c5a825",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Yocco's The Hot Dog King",
      "poi_type": "Restaurants",
      "poi_address": "2128 Hamilton St, Allentown, PA 18104, USA",
      "poi_short_description": "Longstanding cheesesteak and hot dog chain serving burgers, fries, sandwiches and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-beb3-758f-ad84-b7673beca42e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-beb3-758f-ad84-b7673beca42e",
        "storage_key": "property/6767906449166344/019fce09-beb3-758f-ad84-b7673beca42e.webp",
        "width": 1280,
        "height": 1260
      },
      "poi_business_url": "http://www.yoccos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3545760702836160076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoccos-the-hot-dog-king",
      "poi_latitude": "40.5937324",
      "poi_longitude": "-75.50176189999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-821-8488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIRTkoHA5xIkRTLYWr5ISNTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e41ffca7-bcb1-413d-851c-f6e398187f44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Wert's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "515 N 18th St, Allentown, PA 18104, USA",
      "poi_short_description": "This busy, longtime eatery known for its signature burgers also serves other classic American bites.",
      "poi_long_description": "This busy, longtime eatery known for its signature burgers also serves other classic American bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-bf8a-749e-9cef-02da4987e635.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-bf8a-749e-9cef-02da4987e635",
        "storage_key": "property/6767906449166344/019fce09-bf8a-749e-9cef-02da4987e635.webp",
        "width": 1280,
        "height": 632
      },
      "poi_business_url": "http://www.wertscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8262260659361076032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "werts-cafe",
      "poi_latitude": "40.6036021",
      "poi_longitude": "-75.4976485",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-439-0951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJubML8ok5xIkRQNPmWktyqXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d2ee4064-c933-4a02-ad33-30ed5e14a595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Flaming Crab Cajun Seafood",
      "poi_type": "Restaurants",
      "poi_address": "1433 W Allen St, Allentown, PA 18102, USA",
      "poi_short_description": "Casual seafood restaurant dishing up small plates such as shrimp and snow crab.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-c2ed-7079-9959-bacc5755f36f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-c2ed-7079-9959-bacc5755f36f",
        "storage_key": "property/6767906449166344/019fce09-c2ed-7079-9959-bacc5755f36f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.flamingcraballentown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9471026202815664136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flaming-crab-cajun-seafood",
      "poi_latitude": "40.6066748",
      "poi_longitude": "-75.4913792",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-351-1314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcyneQec5xIkRCJA-3SbYb4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dbfd9dbb-2a7a-46fb-a84d-91060b0f917c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Notch Modern Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "5036 Hamilton Blvd, Allentown, PA 18106, USA",
      "poi_short_description": "Relaxed restaurant dishing up American cuisine with Asian influences, plus burgers, fried chicken and duck options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-c567-76f8-a22f-2fa6d1280cdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-c567-76f8-a22f-2fa6d1280cdf",
        "storage_key": "property/6767906449166344/019fce09-c567-76f8-a22f-2fa6d1280cdf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.notchmknb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5327976557700124211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "notch-modern-kitchen--bar",
      "poi_latitude": "40.5653035",
      "poi_longitude": "-75.55543449999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-841-4610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeEjol4wxIkRMw5TTXPG8Ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6c615529-549c-4464-af8b-3db965d4a675",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Bolete",
      "poi_type": "Restaurants",
      "poi_address": "1740 Seidersville Rd, Bethlehem, PA 18015, USA",
      "poi_short_description": "Rustic-chic destination serving a seasonal farm-to-table menu of American cuisine, with a full bar.",
      "poi_long_description": "Rustic-chic destination serving a seasonal farm-to-table menu of American cuisine, with a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-c64e-737c-aba4-f39bc0d8faf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-c64e-737c-aba4-f39bc0d8faf3",
        "storage_key": "property/6767906449166344/019fce09-c64e-737c-aba4-f39bc0d8faf3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.boleterestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13450884497375636781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bolete",
      "poi_latitude": "40.5946965",
      "poi_longitude": "-75.4118034",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 610-868-6505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhabH26E-xIkRLS3iPC8kq7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0bfd2ca4-391a-44ff-a6e5-77ee7c8c846d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Grocery Outlet",
      "poi_type": "Shopping",
      "poi_address": "1401 W Allen St Suite 9, Allentown, PA 18102, USA",
      "poi_short_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_long_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-c657-7729-a844-ac2053b3e00e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-c657-7729-a844-ac2053b3e00e",
        "storage_key": "property/6767906449166344/019fce09-c657-7729-a844-ac2053b3e00e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.groceryoutlet.com/circulars/storeid/734?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=3612961193142436494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grocery-outlet",
      "poi_latitude": "40.606979",
      "poi_longitude": "-75.49082109999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 484-860-3052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6cd5-733d-843a-be90a093f70c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cd5-733d-843a-be90a093f70c",
        "storage_key": "property/6767906449166344/019d026b-6cd5-733d-843a-be90a093f70c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt77k4WI5xIkRjsKGGBDRIzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_168a5e53-ed8f-4c70-9937-a88782df0413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Wegmans",
      "poi_type": "Shopping",
      "poi_address": "3900 Tilghman St, Allentown, PA 18104, USA",
      "poi_short_description": "Large supermarket stocking organic groceries plus a restaurant and an espresso bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-c8db-740f-8941-71e5510d7347.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-c8db-740f-8941-71e5510d7347",
        "storage_key": "property/6767906449166344/019fce09-c8db-740f-8941-71e5510d7347.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.wegmans.com/stores/tilghman-st-pa/?cid=GMB_Wegmans_2024:aw:ow:gb:gb:ao::",
      "poi_directions_map_url": "https://maps.google.com/?cid=16534274730357328614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wegmans",
      "poi_latitude": "40.5917",
      "poi_longitude": "-75.54168",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-336-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6cd5-733d-843a-be90a093f70c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cd5-733d-843a-be90a093f70c",
        "storage_key": "property/6767906449166344/019d026b-6cd5-733d-843a-be90a093f70c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4YRShbwwxIkR5oqq0UOLdeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33f03ace-6636-4c23-8c24-1c8cead985db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "GIANT",
      "poi_type": "Shopping",
      "poi_address": "3070 Tilghman St, Allentown, PA 18104, USA",
      "poi_short_description": "Grocery store chain offering fresh produce, beer, wine, and prepared foods, including sushi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-cbbe-73fe-b7b4-b0a2a1aa4ea5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-cbbe-73fe-b7b4-b0a2a1aa4ea5",
        "storage_key": "property/6767906449166344/019fce09-cbbe-73fe-b7b4-b0a2a1aa4ea5.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://stores.giantfoodstores.com/pa/allentown/3070-tilghman-st?y_source=1_NDE5NTU3Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301156277955379106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant",
      "poi_latitude": "40.5963419",
      "poi_longitude": "-75.5248234",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-776-1531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6cd5-733d-843a-be90a093f70c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cd5-733d-843a-be90a093f70c",
        "storage_key": "property/6767906449166344/019d026b-6cd5-733d-843a-be90a093f70c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUWH0wc6xIkRor_MsL2iDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d7829667-3995-48c3-b62f-a703212237ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Weis Markets",
      "poi_type": "Shopping",
      "poi_address": "1500 N Cedar Crest Blvd, Allentown, PA 18104, USA",
      "poi_short_description": "Fresh produce and flowers along with beer are sold at this grocery store, which typically has a clean interior.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-ccea-77bc-bc17-c5f639c3e436.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-ccea-77bc-bc17-c5f639c3e436",
        "storage_key": "property/6767906449166344/019fce09-ccea-77bc-bc17-c5f639c3e436.webp",
        "width": 1280,
        "height": 459
      },
      "poi_business_url": "https://www.weismarkets.com/stores#/4262",
      "poi_directions_map_url": "https://maps.google.com/?cid=4779656502830454174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "weis-markets",
      "poi_latitude": "40.6116703",
      "poi_longitude": "-75.5351572",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-395-0345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6cd5-733d-843a-be90a093f70c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cd5-733d-843a-be90a093f70c",
        "storage_key": "property/6767906449166344/019d026b-6cd5-733d-843a-be90a093f70c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ZX3GVQ3xIkRnlWY_0PAVEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3f96fb38-1c51-4723-aaf4-68419f68c37e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping",
      "poi_address": "1600 N Cedar Crest Blvd, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-cd5c-7218-9498-c03d8b5e59a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-cd5c-7218-9498-c03d8b5e59a6",
        "storage_key": "property/6767906449166344/019fce09-cd5c-7218-9498-c03d8b5e59a6.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/allentown-pa-pharmacies/1600-n-cedar-crest-blvd-allentown-pa-18104/storeid=16840?WT.mc_id=LS_GOOGLE_RX_16840",
      "poi_directions_map_url": "https://maps.google.com/?cid=269965448558230122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.6126832",
      "poi_longitude": "-75.53549439999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-398-6617",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6cd7-77da-860d-9dd65d0d5d71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cd7-77da-860d-9dd65d0d5d71",
        "storage_key": "property/6767906449166344/019d026b-6cd7-77da-860d-9dd65d0d5d71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5JfzVY3xIkRajrxJiUcvwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_26c9be57-11e6-496d-bfb0-51c22806cb4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "West End Mart",
      "poi_type": "Shopping",
      "poi_address": "1901 W Allen St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-cf7c-7629-a813-3bafa6284f23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-cf7c-7629-a813-3bafa6284f23",
        "storage_key": "property/6767906449166344/019fce09-cf7c-7629-a813-3bafa6284f23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13672659390446485464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-end-mart",
      "poi_latitude": "40.6038503",
      "poi_longitude": "-75.5006466",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 484-860-3259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-67fb-7148-bfd3-a69641545faa",
        "storage_key": "property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl8xnJOU5xIkR2L94VkYLv70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d9523b5-dbc5-41a9-975e-bda0294c1e03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Allen Street Market & Deli",
      "poi_type": "Shopping",
      "poi_address": "Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9450158151678152593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allen-street-market--deli",
      "poi_latitude": "40.6038015",
      "poi_longitude": "-75.5005686",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7e_gaIo5xIkRkc8JFsW0JYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_322a90b6-ac5f-4d27-b34d-a338a5a61afa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping",
      "poi_address": "1600 N Cedar Crest Blvd, Allentown, PA 18104, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-d1dc-76cb-b4a4-a08c630c8303.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-d1dc-76cb-b4a4-a08c630c8303",
        "storage_key": "property/6767906449166344/019fce09-d1dc-76cb-b4a4-a08c630c8303.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/allentown/1510",
      "poi_directions_map_url": "https://maps.google.com/?cid=8561875698236797624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "40.6126654",
      "poi_longitude": "-75.5351481",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-398-4006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-67fb-7148-bfd3-a69641545faa",
        "storage_key": "property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa5JfzVY3xIkRuDJ0tJXk0XY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_465d9a81-1869-4506-a3a4-1a61855ff0ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping",
      "poi_address": "791 N Krocks Rd, Allentown, PA 18106, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-d497-7438-b379-d655e11eada6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-d497-7438-b379-d655e11eada6",
        "storage_key": "property/6767906449166344/019fce09-d497-7438-b379-d655e11eada6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/allentown-PA-1211.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=434764121967165873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "40.5668473",
      "poi_longitude": "-75.5578737",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 484-273-7056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-67fb-7148-bfd3-a69641545faa",
        "storage_key": "property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAdc3kVAwxIkRsQHwWqqXCAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f129e12b-49e5-4762-9321-531f4e978ade",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh Valley Mall",
      "poi_type": "Shopping",
      "poi_address": "250 Lehigh Valley Mall, Whitehall Township, PA 18052, USA",
      "poi_short_description": "Split-level family shopping mall with 3 department stores, global brands, restaurants & a play area.",
      "poi_long_description": "Split-level family shopping mall with 3 department stores, global brands, restaurants & a play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-d428-72ab-b863-9226229253cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-d428-72ab-b863-9226229253cf",
        "storage_key": "property/6767906449166344/019fce09-d428-72ab-b863-9226229253cf.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.simon.com/mall/lehigh-valley-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=13219864170576445532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-mall",
      "poi_latitude": "40.6309043",
      "poi_longitude": "-75.4801037",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-264-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-67fb-7148-bfd3-a69641545faa",
        "storage_key": "property/6767906449166344/019d026b-67fb-7148-bfd3-a69641545faa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ08p65Qc5xIkRXIAf2mtkdrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0157c794-390c-411e-9605-29584dc1e9e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Cetronia Elementary School",
      "poi_type": "Education",
      "poi_address": "3635 Broadway, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cetronia.parklandsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17630049785530001643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cetronia-elementary-school",
      "poi_latitude": "40.5855874",
      "poi_longitude": "-75.5334663",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-351-5860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgx5FtZgwxIkR66j3Nt-EqvQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_909ee374-cdfc-433b-9033-af74d8c213aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Muhlenberg Elementary School",
      "poi_type": "Education",
      "poi_address": "740 N 21st St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-d4fc-761b-90c5-9f2e7ac0c790.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-d4fc-761b-90c5-9f2e7ac0c790",
        "storage_key": "property/6767906449166344/019fce09-d4fc-761b-90c5-9f2e7ac0c790.webp",
        "width": 555,
        "height": 370
      },
      "poi_business_url": "https://muh.allentownsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13116213861445104596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "muhlenberg-elementary-school",
      "poi_latitude": "40.6051055",
      "poi_longitude": "-75.5061606",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 484-765-4861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5zQ33e85xIkR1HN9qQMnBrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_141dbce0-1b7c-4ad4-a345-7213e5178594",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Francis D. Raub Middle School",
      "poi_type": "Education",
      "poi_address": "102 S St Cloud St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-d81e-708e-92d7-eeb5e8fb2d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-d81e-708e-92d7-eeb5e8fb2d03",
        "storage_key": "property/6767906449166344/019fce09-d81e-708e-92d7-eeb5e8fb2d03.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://rau.allentownsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15503621568406914490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "francis-d-raub-middle-school",
      "poi_latitude": "40.5942641",
      "poi_longitude": "-75.493189",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 484-765-5301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTfLaIjA6xIkRuoX6vKztJ9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2e2666e-157c-49fe-92e4-aca398f45390",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "William Allen High School",
      "poi_type": "Education",
      "poi_address": "106 N 17th St, Allentown, PA 18102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-da7a-722e-b55d-a6e74957c040.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-da7a-722e-b55d-a6e74957c040",
        "storage_key": "property/6767906449166344/019fce09-da7a-722e-b55d-a6e74957c040.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://aln.allentownsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4237316622296695807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-allen-high-school",
      "poi_latitude": "40.5985003",
      "poi_longitude": "-75.49381989999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 484-765-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwRko1hM5xIkR_0PaiAT5zTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ec3da877-c02a-41dc-b3ab-41fd9ad684b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Parkland High School",
      "poi_type": "Education",
      "poi_address": "2700 N Cedar Crest Blvd, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-dbbb-77a8-86a2-25ea8e781329.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-dbbb-77a8-86a2-25ea8e781329",
        "storage_key": "property/6767906449166344/019fce09-dbbb-77a8-86a2-25ea8e781329.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://phs.parklandsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9488187377894103924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkland-high-school",
      "poi_latitude": "40.6389567",
      "poi_longitude": "-75.5467286",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-351-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDZ5pgG03xIkRdBu5TSbQrIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4c48db93-f75d-412d-b292-01be7e486642",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Springhouse Middle School",
      "poi_type": "Education",
      "poi_address": "1200 Springhouse Rd, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-dbcc-737e-bdcb-8bc4811d6e54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-dbcc-737e-bdcb-8bc4811d6e54",
        "storage_key": "property/6767906449166344/019fce09-dbcc-737e-bdcb-8bc4811d6e54.webp",
        "width": 650,
        "height": 300
      },
      "poi_business_url": "https://sms.parklandsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11807802790950832845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springhouse-middle-school",
      "poi_latitude": "40.605658",
      "poi_longitude": "-75.54888869999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 610-351-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHQAH_bQwxIkRzYp99BO-3aM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b2160654-9a29-46ba-adbd-a0487c5e431b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Jewish Day School",
      "poi_type": "Education",
      "poi_address": "2313 Pennsylvania St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jdslv.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173327669912194805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jewish-day-school",
      "poi_latitude": "40.6108739",
      "poi_longitude": "-75.5140696",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-437-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAZKP3fA5xIkR9c7wcrgP0bY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5fe8e476-87fc-48dd-8271-863294786833",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Willow Tree Early Learning Center",
      "poi_type": "Education",
      "poi_address": "6750 Iroquois Trail, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-de6a-7789-b593-d311e6906312.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-de6a-7789-b593-d311e6906312",
        "storage_key": "property/6767906449166344/019fce09-de6a-7789-b593-d311e6906312.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://willowtreeearlylearning.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16969962891260213431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-tree-early-learning-center",
      "poi_latitude": "40.5764477",
      "poi_longitude": "-75.5979662",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-351-1147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvYEEUHUxxIkRtzggwVZrges",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_241f3c78-6697-45b3-880b-a169e06599f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Cedar Crest College",
      "poi_type": "Education",
      "poi_address": "100 College Dr, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e147-759e-9c9d-2dc67817f7d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-e147-759e-9c9d-2dc67817f7d2",
        "storage_key": "property/6767906449166344/019fce09-e147-759e-9c9d-2dc67817f7d2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cedarcrest.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10022617737136559099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-crest-college",
      "poi_latitude": "40.5859377",
      "poi_longitude": "-75.5196631",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-437-4471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYx3D2Aw6xIkR-9ON1bp9F4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b4b86dfd-cd5a-41cb-aff2-bf88048c0092",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Muhlenberg College",
      "poi_type": "Education",
      "poi_address": "2400 W Chew St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e2bc-741f-8f0a-fb882aa4ae61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-e2bc-741f-8f0a-fb882aa4ae61",
        "storage_key": "property/6767906449166344/019fce09-e2bc-741f-8f0a-fb882aa4ae61.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.muhlenberg.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3227119637250436272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "muhlenberg-college",
      "poi_latitude": "40.5981933",
      "poi_longitude": "-75.5081076",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 484-664-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx_5yYhk6xIkRsOz_STYIySw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2692b563-21d5-4041-9d57-a65855ad83cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Civic Theatre of Allentown",
      "poi_type": "Entertainment",
      "poi_address": "527 N 19th St, Allentown, PA 18104, USA",
      "poi_short_description": "Mainstage theater for major musicals & plays, plus classic film screenings & workshops for kids.",
      "poi_long_description": "Mainstage theater for major musicals & plays, plus classic film screenings & workshops for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e2ad-7768-b970-b9d202fa94b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-e2ad-7768-b970-b9d202fa94b5",
        "storage_key": "property/6767906449166344/019fce09-e2ad-7768-b970-b9d202fa94b5.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.civictheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15717481588351180613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "civic-theatre-of-allentown",
      "poi_latitude": "40.6032357",
      "poi_longitude": "-75.4997903",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-433-8903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdxyjEIo5xIkRRR9q1Tq2H9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7a45e00e-10ae-447a-82a6-2607a6dc7e3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Sleepy Cat Urban Winery",
      "poi_type": "Entertainment",
      "poi_address": "1840 W Allen St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b11d-72a4-b012-d47f4d04a761.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-b11d-72a4-b012-d47f4d04a761",
        "storage_key": "property/6767906449166344/019fce09-b11d-72a4-b012-d47f4d04a761.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sleepycaturbanwinery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3207473504000088598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sleepy-cat-urban-winery",
      "poi_latitude": "40.6035766",
      "poi_longitude": "-75.4997947",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-351-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSSOPYo5xIkRFhpncCg8gyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a4dd5a5d-200a-4fef-bf6a-49d72e84a931",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "The Udder Bar",
      "poi_type": "Entertainment",
      "poi_address": "1852 W Allen St, Allentown, PA 18104, USA",
      "poi_short_description": "Family-run parlor for housemade ice cream, plus liege waffles, bubble waffles, and edible cookie dough.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b11d-72a4-b012-db03fd385b68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-b11d-72a4-b012-db03fd385b68",
        "storage_key": "property/6767906449166344/019fce09-b11d-72a4-b012-db03fd385b68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theudderbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14310733423270444659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-udder-bar",
      "poi_latitude": "40.6035453",
      "poi_longitude": "-75.4999599",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 484-221-8653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-677c-761e-9143-668f54b6de9b",
        "storage_key": "property/6767906449166344/019d026b-677c-761e-9143-668f54b6de9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqWjlFYo5xIkRcz5YGTrwmcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_da146e02-014c-4487-8a4f-1f0950f3fd10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "The Allentown Fairgrounds",
      "poi_type": "Entertainment",
      "poi_address": "302 N 17th St, Allentown, PA 18104, USA",
      "poi_short_description": "Year-round, indoor farmers market offering baked goods, local produce and seafood, as well as many prepared foods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e4be-7394-973d-715aa98ff261.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-e4be-7394-973d-715aa98ff261",
        "storage_key": "property/6767906449166344/019fce09-e4be-7394-973d-715aa98ff261.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.allentownfairpa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16131484226211080409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-allentown-fairgrounds",
      "poi_latitude": "40.6005516",
      "poi_longitude": "-75.4988327",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-433-7541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxX3fyiA6xIkR2egge2-L3t8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1e867047-c5b3-48cb-ba96-ba3ecc06baa3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Allentown Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "31 N 5th St, Allentown, PA 18101, USA",
      "poi_short_description": "Art gallery featuring permanent & traveling exhibitions on display along with a cafe & gift shop.",
      "poi_long_description": "Art gallery featuring permanent & traveling exhibitions on display along with a cafe & gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e7ec-7764-ba52-1ac8ba8bd5d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-e7ec-7764-ba52-1ac8ba8bd5d2",
        "storage_key": "property/6767906449166344/019fce09-e7ec-7764-ba52-1ac8ba8bd5d2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.allentownartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13231178643366078166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allentown-art-museum",
      "poi_latitude": "40.6043712",
      "poi_longitude": "-75.4678584",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 610-432-4333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6ced-7010-bdd5-999e76ff9f46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6ced-7010-bdd5-999e76ff9f46",
        "storage_key": "property/6767906449166344/019d026b-6ced-7010-bdd5-999e76ff9f46.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJufHDo2Q5xIkR1uaR1d-Wnrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f4e5f916-e758-42b3-a638-c46589989733",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Miller Symphony Hall",
      "poi_type": "Entertainment",
      "poi_address": "23 N 6th St, Allentown, PA 18101, USA",
      "poi_short_description": "Historic 19th-century theater hosting the Allentown Symphony Orchestra & other musical performances.",
      "poi_long_description": "Historic 19th-century theater hosting the Allentown Symphony Orchestra & other musical performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e9d4-72e1-9973-177d935a5c49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-e9d4-72e1-9973-177d935a5c49",
        "storage_key": "property/6767906449166344/019fce09-e9d4-72e1-9973-177d935a5c49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.millersymphonyhall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729422506088034312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miller-symphony-hall",
      "poi_latitude": "40.60367979999999",
      "poi_longitude": "-75.4699926",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 610-432-7961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYQp3sXw5xIkRCHC5jAKSwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_532c3b91-fd0b-497e-b42c-390322833a50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "America On Wheels Museum",
      "poi_type": "Entertainment",
      "poi_address": "5 N Front St, Allentown, PA 18102, USA",
      "poi_short_description": "Museum dedicated to wheeled transportation, from automobiles to scooters plus a cafe & gift shop.",
      "poi_long_description": "Museum dedicated to wheeled transportation, from automobiles to scooters plus a cafe & gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e996-776b-9291-7cb4c3c4141b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-e996-776b-9291-7cb4c3c4141b",
        "storage_key": "property/6767906449166344/019fce09-e996-776b-9291-7cb4c3c4141b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.americaonwheels.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13567134994674369887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "america-on-wheels-museum",
      "poi_latitude": "40.606715",
      "poi_longitude": "-75.456499",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 610-432-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6ced-7010-bdd5-999e76ff9f46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6ced-7010-bdd5-999e76ff9f46",
        "storage_key": "property/6767906449166344/019d026b-6ced-7010-bdd5-999e76ff9f46.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJW7PQT105xIkRX0VWWWUlSLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33f4f888-3202-442f-8749-273179b3198a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh Valley Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "432 Walnut St, Allentown, PA 18102, USA",
      "poi_short_description": "One of the largest historical society museums in the country, with 6 galleries on area history.",
      "poi_long_description": "One of the largest historical society museums in the country, with 6 galleries on area history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-eb88-727f-a6ce-19d69a4e4d80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-eb88-727f-a6ce-19d69a4e4d80",
        "storage_key": "property/6767906449166344/019fce09-eb88-727f-a6ce-19d69a4e4d80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lehighvalleyheritagemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3666455750517721189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-heritage-museum",
      "poi_latitude": "40.6019048",
      "poi_longitude": "-75.4658966",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 610-435-1074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6ced-7010-bdd5-999e76ff9f46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6ced-7010-bdd5-999e76ff9f46",
        "storage_key": "property/6767906449166344/019d026b-6ced-7010-bdd5-999e76ff9f46.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJyZqNk2M5xIkRZQhMUhTe4TI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a799d932-9117-4d3f-bdb2-e3b50c7324f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "PPL Center",
      "poi_type": "Entertainment",
      "poi_address": "701 Hamilton St, Allentown, PA 18101, USA",
      "poi_short_description": "Contemporary indoor arena hosting various sporting events, concerts & touring productions.",
      "poi_long_description": "Contemporary indoor arena hosting various sporting events, concerts & touring productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-ef0a-730b-a9cf-34abdb5f8249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-ef0a-730b-a9cf-34abdb5f8249",
        "storage_key": "property/6767906449166344/019fce09-ef0a-730b-a9cf-34abdb5f8249.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pplcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10931247651091595831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ppl-center",
      "poi_latitude": "40.602668",
      "poi_longitude": "-75.472915",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-224-4625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdLK8Hw5xIkRN0Iji9KXs5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_647ff122-d8c7-4c8f-bb1d-6d256d6c72b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Frank Banko Alehouse Cinemas",
      "poi_type": "Entertainment",
      "poi_address": "101 Founders Way, Bethlehem, PA 18015, USA",
      "poi_short_description": "Independent cinema with 2 screens seating 100 & 200 people showing international & arthouse films.",
      "poi_long_description": "Independent cinema with 2 screens seating 100 & 200 people showing international & arthouse films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f002-701b-aeae-adbbd1727b11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-f002-701b-aeae-adbbd1727b11",
        "storage_key": "property/6767906449166344/019fce09-f002-701b-aeae-adbbd1727b11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.steelstacks.org/about/venues-at-steelstacks/frank-banko-alehouse-cinemas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10687887220542787934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frank-banko-alehouse-cinemas",
      "poi_latitude": "40.6140913",
      "poi_longitude": "-75.3678439",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 610-332-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-71ca-7409-aada-d8bcbcab2143.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71ca-7409-aada-d8bcbcab2143",
        "storage_key": "property/6767906449166344/019d026b-71ca-7409-aada-d8bcbcab2143.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfVbSUY-xIkRXtHj28wAU5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_319167eb-7bda-4ade-8ed4-81af51e8f0f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh Valley Hospital–Cedar Crest",
      "poi_type": "Health",
      "poi_address": "1200 S Cedar Crest Blvd, Allentown, PA 18103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f0e4-76ea-8c28-2c001412b2ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-f0e4-76ea-8c28-2c001412b2ee",
        "storage_key": "property/6767906449166344/019fce09-f0e4-76ea-8c28-2c001412b2ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lvhn.org/locations/lehigh-valley-hospital-cedar-crest",
      "poi_directions_map_url": "https://maps.google.com/?cid=11224698833635954574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-hospitalcedar-crest",
      "poi_latitude": "40.5664156",
      "poi_longitude": "-75.5238103",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-402-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-71c7-7154-bb2a-74a368881248.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c7-7154-bb2a-74a368881248",
        "storage_key": "property/6767906449166344/019d026b-71c7-7154-bb2a-74a368881248.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14vd8Yc6xIkRjs-cQR4kxps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c37ddb22-9ab1-4b56-87cd-ad7afd617c3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "St. Luke's Hospital - Allentown Campus",
      "poi_type": "Health",
      "poi_address": "1736 Hamilton St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f20e-74b8-86b4-79c9f692946d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-f20e-74b8-86b4-79c9f692946d",
        "storage_key": "property/6767906449166344/019fce09-f20e-74b8-86b4-79c9f692946d.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.slhn.org/locations/stlukes-hospital-allentown-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=4967321612984614045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-hospital---allentown-campus",
      "poi_latitude": "40.5956367",
      "poi_longitude": "-75.49277339999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 866-785-8537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-71c7-7154-bb2a-74a368881248.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c7-7154-bb2a-74a368881248",
        "storage_key": "property/6767906449166344/019d026b-71c7-7154-bb2a-74a368881248.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJM96rjCU6xIkRnXwRY7B470Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_54abf6d7-bd14-489a-8fb5-575bda4a7546",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "St. Luke's Care Now - Allentown (Walk-in care) and Occupational Medicine",
      "poi_type": "Health",
      "poi_address": "501 Cetronia Rd Suite 105, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f51a-7492-a808-d0525bc5fd06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-f51a-7492-a808-d0525bc5fd06",
        "storage_key": "property/6767906449166344/019fce09-f51a-7492-a808-d0525bc5fd06.webp",
        "width": 1128,
        "height": 846
      },
      "poi_business_url": "https://www.slhn.org/locations/stlukes-carenow-allentown-walk-in-care-and-occupational-medicine",
      "poi_directions_map_url": "https://maps.google.com/?cid=1517604695606860720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-care-now---allentown-walk-in-care-and-occupational-medicine",
      "poi_latitude": "40.5851994",
      "poi_longitude": "-75.5566271",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 484-426-2513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_ja-OswxIkRsJscF26dDxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63c36a59-15f7-46dd-9634-99cdd3ee84cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "St. Luke's Fitness & Sports Performance Center - West End",
      "poi_type": "Health",
      "poi_address": "501 Cetronia Rd, Allentown, PA 18104, USA",
      "poi_short_description": "Spacious fitness center featuring aerobic machines, weight training equipment, turf and staff assistance.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f5a7-77ca-9854-51056a2ec8df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-f5a7-77ca-9854-51056a2ec8df",
        "storage_key": "property/6767906449166344/019fce09-f5a7-77ca-9854-51056a2ec8df.webp",
        "width": 1128,
        "height": 634
      },
      "poi_business_url": "https://www.slhn.org/locations/stlukes-fitness-sports-performance-center-west-end",
      "poi_directions_map_url": "https://maps.google.com/?cid=11970930270308025049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-fitness--sports-performance-center---west-end",
      "poi_latitude": "40.5856042",
      "poi_longitude": "-75.5566619",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 484-426-2540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7ys_-swxIkR2UKu-KdJIaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2d3fba63-6eed-4446-86fd-58c5ef3d6724",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health",
      "poi_address": "3010 Tilghman St, Allentown, PA 18104, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f73d-778d-942b-230e59d5c9e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-f73d-778d-942b-230e59d5c9e5",
        "storage_key": "property/6767906449166344/019fce09-f73d-778d-942b-230e59d5c9e5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/allentown-pa-pharmacies/3010-tilghman-street-allentown-pa-18104/storeid=461?WT.mc_id=LS_GOOGLE_FS_461",
      "poi_directions_map_url": "https://maps.google.com/?cid=6502028485962951959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.5979969",
      "poi_longitude": "-75.5246325",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-776-6551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOfYXqgc6xIkRF-1KcXXYO1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a390a8ac-baf5-452a-a070-4a09bced2f2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy - 1702 Tilghman",
      "poi_type": "Health",
      "poi_address": "1702 Tilghman St, Allentown, PA 18104, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f867-70f0-81a0-186771436fd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-f867-70f0-81a0-186771436fd4",
        "storage_key": "property/6767906449166344/019fce09-f867-70f0-81a0-186771436fd4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1702+w+tilghman+st-allentown-pa-18104/id=5715",
      "poi_directions_map_url": "https://maps.google.com/?cid=9381314301461502006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "40.6053677",
      "poi_longitude": "-75.4970089",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-435-3605",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6cd7-77da-860d-9dd65d0d5d71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cd7-77da-860d-9dd65d0d5d71",
        "storage_key": "property/6767906449166344/019d026b-6cd7-77da-860d-9dd65d0d5d71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBe8_DYk5xIkRNpjnIKcfMYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7912b88a-743d-4a1b-a5e2-e45a790fe53f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Wegmans Pharmacy - 3900 Tilghman",
      "poi_type": "Health",
      "poi_address": "3900 Tilghman St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-faff-75e9-a943-da1d01d86c7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-faff-75e9-a943-da1d01d86c7d",
        "storage_key": "property/6767906449166344/019fce09-faff-75e9-a943-da1d01d86c7d.webp",
        "width": 1280,
        "height": 805
      },
      "poi_business_url": "https://www.wegmans.com/pharmacy/?cid=GMB_Pharmacy_2024:aw:ow:gb:gb:ao::",
      "poi_directions_map_url": "https://maps.google.com/?cid=8920189552029442760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wegmans-pharmacy",
      "poi_latitude": "40.5917",
      "poi_longitude": "-75.54168",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-336-7940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6cd7-77da-860d-9dd65d0d5d71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cd7-77da-860d-9dd65d0d5d71",
        "storage_key": "property/6767906449166344/019d026b-6cd7-77da-860d-9dd65d0d5d71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4J3ibwwxIkRyKLd6SLhyns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1244da90-e59a-41b6-a101-18be86eaf6dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health",
      "poi_address": "4701 Tilghman St, Allentown, PA 18104, USA",
      "poi_short_description": "Chain gym offering tanning, hydro massages, and other fitness amenities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-fb6b-72bd-8141-e98922a78e3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-fb6b-72bd-8141-e98922a78e3c",
        "storage_key": "property/6767906449166344/019fce09-fb6b-72bd-8141-e98922a78e3c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/allentown-west-pa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12264963159493534266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.5915037",
      "poi_longitude": "-75.560518",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-366-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbt4roU5xIkROmLd0ALnNao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6a7ed634-3260-4616-bbb8-8559f8d07df3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health",
      "poi_address": "4713 Tilghman St, Allentown, PA 18104, USA",
      "poi_short_description": "Gym, studio and fitness center with motivational trainers offering group heart-rate monitoring sessions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-fd96-7245-bbe9-96857279378e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-fd96-7245-bbe9-96857279378e",
        "storage_key": "property/6767906449166344/019fce09-fd96-7245-bbe9-96857279378e.webp",
        "width": 1280,
        "height": 627
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/allentown-pennsylvania-1021?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=2979607585535141023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "40.5911471",
      "poi_longitude": "-75.56146679999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-366-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJESJAM9UxxIkRn6Th-U-xWSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_10fdfec2-6899-454a-9a3a-94c4f9b4b63a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "West End Yoga Center",
      "poi_type": "Health",
      "poi_address": "2313 W Highland St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-ffa6-741a-8130-814b1fa04ba9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-ffa6-741a-8130-814b1fa04ba9",
        "storage_key": "property/6767906449166344/019fce09-ffa6-741a-8130-814b1fa04ba9.webp",
        "width": 1280,
        "height": 984
      },
      "poi_business_url": "http://www.weyogacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13873286579623963879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-end-yoga-center",
      "poi_latitude": "40.6091533",
      "poi_longitude": "-75.513395",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 484-860-3044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI11RKvc5xIkR5yyu7aPQh8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_46e5b50e-b52f-4875-8345-56d9da01a59a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Trexler Memorial Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "155 Springhouse Rd, Allentown, PA 18104, USA",
      "poi_short_description": "Scenic park with large old trees, grassy lawns & a duck pond, plus paths for cycling & running.",
      "poi_long_description": "Scenic park with large old trees, grassy lawns & a duck pond, plus paths for cycling & running.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-01ee-733c-9d00-08755f379880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-01ee-733c-9d00-08755f379880",
        "storage_key": "property/6767906449166344/019fce0a-01ee-733c-9d00-08755f379880.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.allentownpa.gov/en-us/Government/Departments/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=7216141211056605491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trexler-memorial-park",
      "poi_latitude": "40.590329",
      "poi_longitude": "-75.52931339999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-437-7757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7216-741e-8be2-bc73a29844b0",
        "storage_key": "property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwoRHqcwxIkRMwkW3jLiJGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_49f7d87e-5c2b-497b-b727-a99659749f9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Cedar Beach Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "2600 Parkway Blvd, Allentown, PA 18104, USA",
      "poi_short_description": "Grassy, tree-filled park with a small lake & outdoor pool, plus basketball & volleyball courts.",
      "poi_long_description": "Grassy, tree-filled park with a small lake & outdoor pool, plus basketball & volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-0236-768f-8f8f-9f41f1972298.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-0236-768f-8f8f-9f41f1972298",
        "storage_key": "property/6767906449166344/019fce0a-0236-768f-8f8f-9f41f1972298.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.allentownpa.gov/en-us/Government/Departments/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=2003574857430613780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-beach-park",
      "poi_latitude": "40.5934893",
      "poi_longitude": "-75.5114502",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-437-7757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7216-741e-8be2-bc73a29844b0",
        "storage_key": "property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP26WgBA6xIkRFD8Oqrcgzhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_586a5597-8443-443b-a280-4c8daa0cf15e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Malcolm Gross Rose Garden",
      "poi_type": "Outdoor Attractions",
      "poi_address": "Allentown, PA 18104, USA",
      "poi_short_description": "Scenic rose garden featuring paved walking paths, 3 pavilions & a fitness/exercise trail.",
      "poi_long_description": "Scenic rose garden featuring paved walking paths, 3 pavilions & a fitness/exercise trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-04ba-73ce-bae6-ad52f3400982.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-04ba-73ce-bae6-ad52f3400982",
        "storage_key": "property/6767906449166344/019fce0a-04ba-73ce-bae6-ad52f3400982.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.allentownpa.gov/Parks-and-Recreation/Parks/Rose-Garden-Weddings",
      "poi_directions_map_url": "https://maps.google.com/?cid=701019652723188631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "malcolm-gross-rose-garden",
      "poi_latitude": "40.5918326",
      "poi_longitude": "-75.515779",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-437-7750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7216-741e-8be2-bc73a29844b0",
        "storage_key": "property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWb_j1hE6xIkRlyMi9aiFugk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_18df9dab-0ad3-4f9f-b470-21db642fb3d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Haines Mill Museum",
      "poi_type": "Outdoor Attractions",
      "poi_address": "3600 Haines Mill Rd, Allentown, PA 18104, USA",
      "poi_short_description": "Picturesque, serene mill setting with pristine machinery and flowers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-0752-75f2-8fa4-5627500fcb15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-0752-75f2-8fa4-5627500fcb15",
        "storage_key": "property/6767906449166344/019fce0a-0752-75f2-8fa4-5627500fcb15.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lehighcounty.org/Departments/Parks-And-Recreation/Our-Parks/Cedar-Creek-Parkway-East",
      "poi_directions_map_url": "https://maps.google.com/?cid=5402055169973989819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "haines-mill-museum",
      "poi_latitude": "40.5846769",
      "poi_longitude": "-75.53153549999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-435-4664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6ced-7010-bdd5-999e76ff9f46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6ced-7010-bdd5-999e76ff9f46",
        "storage_key": "property/6767906449166344/019d026b-6ced-7010-bdd5-999e76ff9f46.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4uFG58wxIkRu7FcR47090o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_112b59ed-34bd-40b6-ba83-708db9a08d5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Dorney Park & Wildwater Kingdom",
      "poi_type": "Outdoor Attractions",
      "poi_address": "3830 Dorney Park Rd, Allentown, PA 18104, USA",
      "poi_short_description": "Theme park with coasters, thrill rides, waterslides, dining & shows, plus Snoopy-themed kids' area.",
      "poi_long_description": "Theme park with coasters, thrill rides, waterslides, dining & shows, plus Snoopy-themed kids' area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-08a1-706d-8172-ac784a634df5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-08a1-706d-8172-ac784a634df5",
        "storage_key": "property/6767906449166344/019fce0a-08a1-706d-8172-ac784a634df5.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.dorneypark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5678167536323586850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorney-park--wildwater-kingdom",
      "poi_latitude": "40.57853009999999",
      "poi_longitude": "-75.5326285",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-395-3724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXlkPpswxIkRIuu4QUrnzE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5796e209-839b-4561-be92-842e9d9bb2e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Li'l-Le-Hi Trout Nursery",
      "poi_type": "Outdoor Attractions",
      "poi_address": "2901 Fish Hatchery Rd, Allentown, PA 18103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-0a52-724c-a8b2-73b1a9b5bdf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-0a52-724c-a8b2-73b1a9b5bdf7",
        "storage_key": "property/6767906449166344/019fce0a-0a52-724c-a8b2-73b1a9b5bdf7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.allentownpa.gov/Parks-and-Recreation/Parks/Park-Inventory/Lil-Le-Hi-Trout-Nursery/fbclid/IwAR0-s1sCgzsuqXY3npKbqejMc9WUFqdvn12t6vGcFC-n-pYfHnZCC2mC8nM",
      "poi_directions_map_url": "https://maps.google.com/?cid=14499279370995072628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lil-le-hi-trout-nursery",
      "poi_latitude": "40.5642906",
      "poi_longitude": "-75.5136912",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-437-7656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2TWUF4k6xIkRdH5Pd8TJN8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_60437065-2470-40d3-9aec-a091644f8aa1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh Parkway",
      "poi_type": "Outdoor Attractions",
      "poi_address": "Lehigh Parkway E, Allentown, PA 18103, USA",
      "poi_short_description": "Historic park provides running & biking trails through scenic grounds with a creek & covered bridge.",
      "poi_long_description": "Historic park provides running & biking trails through scenic grounds with a creek & covered bridge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-0be2-749c-aa5b-7a0511f26261.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-0be2-749c-aa5b-7a0511f26261",
        "storage_key": "property/6767906449166344/019fce0a-0be2-749c-aa5b-7a0511f26261.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1292070099346057537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-parkway",
      "poi_latitude": "40.5790326",
      "poi_longitude": "-75.4930888",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-437-7757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7216-741e-8be2-bc73a29844b0",
        "storage_key": "property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59GnGkQ6xIkRQels4Oha7hE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4a9af118-e2c1-40ba-be77-9614e7a93273",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Jordan Creek Parkway",
      "poi_type": "Outdoor Attractions",
      "poi_address": "1401 Lehnert Rd, Whitehall Township, PA 18052, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-0f29-772c-b7e3-3902dba5c08d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-0f29-772c-b7e3-3902dba5c08d",
        "storage_key": "property/6767906449166344/019fce0a-0f29-772c-b7e3-3902dba5c08d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14876396177903684036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jordan-creek-parkway",
      "poi_latitude": "40.62401819999999",
      "poi_longitude": "-75.49853030000001",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7216-741e-8be2-bc73a29844b0",
        "storage_key": "property/6767906449166344/019d026b-7216-741e-8be2-bc73a29844b0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBThhcKI5xIkRxIntWYGTc84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f200edcf-94f2-4d65-82cb-d259f4de4207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Allentown Transit Center",
      "poi_type": "Transit",
      "poi_address": "112 N 6th St, Allentown, PA 18101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5170926753153624930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allentown-transit-center",
      "poi_latitude": "40.6044908",
      "poi_longitude": "-75.4707018",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_ZwzfUo5xIkRYitJOXzSwkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ddcb2d5-2083-41b3-bb30-8d32ef86bcff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh Valley International Airport",
      "poi_type": "Transit",
      "poi_address": "3311 Airport Rd, Allentown, PA 18109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-0f97-70fb-89e6-1c77448a642b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-0f97-70fb-89e6-1c77448a642b",
        "storage_key": "property/6767906449166344/019fce0a-0f97-70fb-89e6-1c77448a642b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flyabe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=807841022593771884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-international-airport",
      "poi_latitude": "40.6510611",
      "poi_longitude": "-75.44388529999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-359-5842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-7211-71ea-ae3f-b586d832a971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7211-71ea-ae3f-b586d832a971",
        "storage_key": "property/6767906449166344/019d026b-7211-71ea-ae3f-b586d832a971.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ866awjQ_xIkRbKmwQiEHNgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3c3e492f-e9a9-4df9-977e-27082021ff2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh and Northampton Transportation Authority",
      "poi_type": "Transit",
      "poi_address": "1060 Lehigh St, Allentown, PA 18103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-10bd-7394-916b-0699fb574fba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-10bd-7394-916b-0699fb574fba",
        "storage_key": "property/6767906449166344/019fce0a-10bd-7394-916b-0699fb574fba.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.lantabus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1414170514898672749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-and-northampton-transportation-authority",
      "poi_latitude": "40.5871248",
      "poi_longitude": "-75.4768244",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-776-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTWZbSsw7xIkRbdxdOJckoBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_28427c0f-1917-47e3-ad79-bc2dbedd4012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Bethlehem Transportation Center",
      "poi_type": "Transit",
      "poi_address": "635 Guetter St, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-1292-77fc-bbe1-83e86abbe48e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-1292-77fc-bbe1-83e86abbe48e",
        "storage_key": "property/6767906449166344/019fce0a-1292-77fc-bbe1-83e86abbe48e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lantabus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6933764805591296958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethlehem-transportation-center",
      "poi_latitude": "40.6231285",
      "poi_longitude": "-75.3806652",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 610-867-3988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgw8oXlk_xIkRvutfoVquOWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3908d7cb-f38b-4303-8c98-6bb0240adcf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "EITC - Easton Intermodal Transit Center",
      "poi_type": "Transit",
      "poi_address": "Easton, PA 18042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-1567-71bc-864e-a6b8f1aead28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-1567-71bc-864e-a6b8f1aead28",
        "storage_key": "property/6767906449166344/019fce0a-1567-71bc-864e-a6b8f1aead28.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10771326887449146082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eitc---easton-intermodal-transit-center",
      "poi_latitude": "40.688964",
      "poi_longitude": "-75.209638",
      "poi_miles_from_property": "19.8 mi",
      "poi_walking_minutes": "7 hours 23 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYy4s11ZsxIkR4jIFNrxwe5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fda3b26a-5684-4d2a-83c3-48eb13d3aa0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Allentown - Wescosville, PA (PennDOT Wescosville Park and Ride off Schuler Street and Charcoal Drive. Children under 4 years of age are not allowed on buses operated by Kleins Bus Service)",
      "poi_type": "Transit",
      "poi_address": "Wescosville, PA 18103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10222218591659255828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allentown---wescosville-pa-penndot-wescosville-park-and-ride-off-schuler-street-and-charcoal-drive-children-under-4-years-of-age-are-not-allowed-on-buses-operated-by-kleins-bus-service",
      "poi_latitude": "40.5699309",
      "poi_longitude": "-75.5434085",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaeip84kwxIkRFGg-RKad3I0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e926df97-3b97-45f1-bddd-c01474da81e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Allentown Transportation Deck",
      "poi_type": "Transit",
      "poi_address": "603 Linden St, Allentown, PA 18101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.allentownparking.com/parking/decks-lots/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3177325217452548613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allentown-transportation-deck",
      "poi_latitude": "40.6041646",
      "poi_longitude": "-75.4709015",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 484-294-5240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-76ff-72fc-ad2e-2b2bc3f4757f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-76ff-72fc-ad2e-2b2bc3f4757f",
        "storage_key": "property/6767906449166344/019d026b-76ff-72fc-ad2e-2b2bc3f4757f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJG81SZ3s5xIkRBWImenMgGCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fda10012-0482-45ce-9188-3caf6e3256be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Muhlenberg College",
      "poi_type": "Major Employers",
      "poi_address": "2400 W Chew St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e2bc-741f-8f0a-fb882aa4ae61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-e2bc-741f-8f0a-fb882aa4ae61",
        "storage_key": "property/6767906449166344/019fce09-e2bc-741f-8f0a-fb882aa4ae61.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.muhlenberg.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3227119637250436272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "muhlenberg-college",
      "poi_latitude": "40.5981933",
      "poi_longitude": "-75.5081076",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 484-664-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx_5yYhk6xIkRsOz_STYIySw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ce225bbd-a50b-4bff-938b-df1b10840cbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Cedar Crest College",
      "poi_type": "Major Employers",
      "poi_address": "100 College Dr, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e147-759e-9c9d-2dc67817f7d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-e147-759e-9c9d-2dc67817f7d2",
        "storage_key": "property/6767906449166344/019fce09-e147-759e-9c9d-2dc67817f7d2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cedarcrest.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10022617737136559099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-crest-college",
      "poi_latitude": "40.5859377",
      "poi_longitude": "-75.5196631",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-437-4471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYx3D2Aw6xIkR-9ON1bp9F4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cd566cac-b10a-466b-a445-4da4c7ad3d51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh Valley Hospital–Cedar Crest",
      "poi_type": "Major Employers",
      "poi_address": "1200 S Cedar Crest Blvd, Allentown, PA 18103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f0e4-76ea-8c28-2c001412b2ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-f0e4-76ea-8c28-2c001412b2ee",
        "storage_key": "property/6767906449166344/019fce09-f0e4-76ea-8c28-2c001412b2ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lvhn.org/locations/lehigh-valley-hospital-cedar-crest",
      "poi_directions_map_url": "https://maps.google.com/?cid=11224698833635954574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-hospitalcedar-crest",
      "poi_latitude": "40.5664156",
      "poi_longitude": "-75.5238103",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-402-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-71c7-7154-bb2a-74a368881248.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c7-7154-bb2a-74a368881248",
        "storage_key": "property/6767906449166344/019d026b-71c7-7154-bb2a-74a368881248.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14vd8Yc6xIkRjs-cQR4kxps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac4fb329-98cf-4c8a-b7ff-ffbf334131aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "St. Luke's Hospital - Allentown Campus",
      "poi_type": "Major Employers",
      "poi_address": "1736 Hamilton St, Allentown, PA 18104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f20e-74b8-86b4-79c9f692946d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-f20e-74b8-86b4-79c9f692946d",
        "storage_key": "property/6767906449166344/019fce09-f20e-74b8-86b4-79c9f692946d.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.slhn.org/locations/stlukes-hospital-allentown-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=4967321612984614045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-hospital---allentown-campus",
      "poi_latitude": "40.5956367",
      "poi_longitude": "-75.49277339999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 866-785-8537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-71c7-7154-bb2a-74a368881248.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c7-7154-bb2a-74a368881248",
        "storage_key": "property/6767906449166344/019d026b-71c7-7154-bb2a-74a368881248.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJM96rjCU6xIkRnXwRY7B470Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5aebcae8-0853-4a81-a7a6-8344a33c6f3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "PPL Corporation",
      "poi_type": "Major Employers",
      "poi_address": "645 Hamilton St Suite 601, Allentown, PA 18101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-164b-77ba-80cc-5979b660a531.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-164b-77ba-80cc-5979b660a531",
        "storage_key": "property/6767906449166344/019fce0a-164b-77ba-80cc-5979b660a531.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pplweb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3909012689617477075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ppl-corporation",
      "poi_latitude": "40.6027013",
      "poi_longitude": "-75.4713338",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-774-5151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCa5Oen45xIkR090kk1SaPzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0489b803-a570-4d24-968e-68ba135b9d76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Air Products and Chemicals, Inc.",
      "poi_type": "Major Employers",
      "poi_address": "1940 Air Products Blvd, Allentown, PA 18106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-1866-7523-9caa-b6c1fd695bb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-1866-7523-9caa-b6c1fd695bb2",
        "storage_key": "property/6767906449166344/019fce0a-1866-7523-9caa-b6c1fd695bb2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.airproducts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1528790162020138751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "air-products-and-chemicals-inc",
      "poi_latitude": "40.5601798",
      "poi_longitude": "-75.5816215",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-481-4911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6783-7507-bd1b-2bf377c635f6",
        "storage_key": "property/6767906449166344/019d026b-6783-7507-bd1b-2bf377c635f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8-GoQoixIkR_35Sb41aNxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dc040a1b-55a0-41bd-8e8a-6b3f8101b45d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh University",
      "poi_type": "Major Employers",
      "poi_address": "27 Memorial Dr W, Bethlehem, PA 18015, USA",
      "poi_short_description": "Research-geared private school known for its large, rural campus & business & engineering programs.",
      "poi_long_description": "Research-geared private school known for its large, rural campus & business & engineering programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-18ff-70d7-8703-758a31da6d56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-18ff-70d7-8703-758a31da6d56",
        "storage_key": "property/6767906449166344/019fce0a-18ff-70d7-8703-758a31da6d56.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.lehigh.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6751153047229936416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-university",
      "poi_latitude": "40.6054003",
      "poi_longitude": "-75.3771764",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 610-758-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6c7a-72ab-ad5d-514bf45a80a8",
        "storage_key": "property/6767906449166344/019d026b-6c7a-72ab-ad5d-514bf45a80a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5WpcfWc-xIkRILNvZO3psF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9be9e512-3011-4622-87af-18b4cdf6d5a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh Valley International Airport",
      "poi_type": "Major Employers",
      "poi_address": "3311 Airport Rd, Allentown, PA 18109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-0f97-70fb-89e6-1c77448a642b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-0f97-70fb-89e6-1c77448a642b",
        "storage_key": "property/6767906449166344/019fce0a-0f97-70fb-89e6-1c77448a642b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flyabe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=807841022593771884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-international-airport",
      "poi_latitude": "40.6510611",
      "poi_longitude": "-75.44388529999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-359-5842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-7211-71ea-ae3f-b586d832a971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7211-71ea-ae3f-b586d832a971",
        "storage_key": "property/6767906449166344/019d026b-7211-71ea-ae3f-b586d832a971.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ866awjQ_xIkRbKmwQiEHNgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31d9c49f-dfe4-411a-a444-f9228a911f91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Allentown City Hall",
      "poi_type": "Major Employers",
      "poi_address": "435 Hamilton St, Allentown, PA 18101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-1c25-7399-b434-6e59940b6ac8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-1c25-7399-b434-6e59940b6ac8",
        "storage_key": "property/6767906449166344/019fce0a-1c25-7399-b434-6e59940b6ac8.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.allentownpa.gov/en-us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135628359803736972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allentown-city-hall",
      "poi_latitude": "40.60381539999999",
      "poi_longitude": "-75.46688329999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 610-439-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-773b-748d-9b62-16054c53527b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-773b-748d-9b62-16054c53527b",
        "storage_key": "property/6767906449166344/019d026b-773b-748d-9b62-16054c53527b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdwdgWQ5xIkRjBMKdxnXK8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3410fbd8-29a9-400f-ac55-83e029c16cb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "poi_name": "Lehigh County Government Center",
      "poi_type": "Major Employers",
      "poi_address": "17 S 7th St, Allentown, PA 18101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-1d80-77ba-b5dd-4b673d440efe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0a-1d80-77ba-b5dd-4b673d440efe",
        "storage_key": "property/6767906449166344/019fce0a-1d80-77ba-b5dd-4b673d440efe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lehighcounty.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17367289253946741573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-county-government-center",
      "poi_latitude": "40.6018791",
      "poi_longitude": "-75.4707717",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 610-782-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026b-773b-748d-9b62-16054c53527b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-773b-748d-9b62-16054c53527b",
        "storage_key": "property/6767906449166344/019d026b-773b-748d-9b62-16054c53527b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TLu3Xw5xIkRRVP0hI8BBfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_d6c3031b-fcdd-4258-8cc8-8b1d84b3595e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9fa68718-5418-435c-a4af-b21e8e5f743f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_408ac4a4-f5c5-442d-8481-fd8f2079dd88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d7fcb0d3-0f44-4281-bf60-e815b6ae33f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_157c1089-47c7-4841-87c2-995d769ca8b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "custom_0a98fc56-9792-493c-aa1b-80e3d3d56a5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-a5ca-72db-a5b7-f14e321404db.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fce09-a5ca-72db-a5b7-f14e321404db",
        "storage_key": "property/6767906449166344/019fce09-a5ca-72db-a5b7-f14e321404db.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,584SF",
      "virtual_tour_type": "",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JNuNXWqgNgM&play=1"
    },
    {
      "id": "custom_ac43ffeb-2913-4168-9d4b-457484884ef7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-a06c-7539-b2e0-67746822a457.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fce09-a06c-7539-b2e0-67746822a457",
        "storage_key": "property/6767906449166344/019fce09-a06c-7539-b2e0-67746822a457.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2.5BA - 2,200SF",
      "virtual_tour_type": "",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Y6uEqWcWeyd&play=1"
    },
    {
      "id": "custom_9148e5d4-520c-4ffb-93f3-90716453ab46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-a0dc-778d-99d6-9dcdaa16d66a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fce09-a0dc-778d-99d6-9dcdaa16d66a",
        "storage_key": "property/6767906449166344/019fce09-a0dc-778d-99d6-9dcdaa16d66a.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Outdoor Patio and Grills",
      "virtual_tour_type": "",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kQuuSNftEYX&play=1"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1324-4f90-72ae-a22d-14a933a383fc",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-springhouse-townhomes-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344"
    },
    {
      "lead_collector_id": "019c3043-9823-75e8-8101-93ef36c3b547",
      "lead_source": "FACEBOOK_ADS",
      "name": "springhouse-townhomes",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344"
    },
    {
      "lead_collector_id": "019c3043-9892-738a-ab86-c465cf8420f1",
      "lead_source": "LANDING_PAGE",
      "name": "springhouse-townhomes",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "pet-friendly-townhomes-springhouse-allentown-pa-888",
      "search_query": "pet friendly townhomes Allentown PA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Townhomes in Allentown, PA",
      "h2_subtitle": "Discover the best pet friendly townhomes Allentown PA has to offer. Springhouse Townhomes welcomes you and your furry friends in style and comfort.",
      "page_copy": "Finding pet friendly townhomes in Allentown, PA is easy at Springhouse Townhomes. Our spacious two and three-bedroom layouts are perfect for pet lovers, featuring amenities that cater to both you and your furry companions. Enjoy grilling stations and walking trails just steps from your door, providing ample opportunities for you and your pet to enjoy the outdoors together. Each unit boasts upgraded kitchens with granite countertops and track lighting, creating a modern home.\n\nLocated in the vibrant West End of Allentown, Springhouse Townhomes offer a convenient lifestyle to all residents. The scenic views and renovated interiors are just the beginning. Use our online resident portal and flex rent payments for seamless living. Whether you're taking a walk along our trails or enjoying the company of neighbors, Springhouse Townhomes provide the perfect community for pet owners seeking comfort and convenience in Allentown, PA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Townhomes in Allentown, PA",
      "seo_description": "Explore pet friendly townhomes in Allentown, PA at Springhouse Townhomes. Enjoy walking trails and modern amenities. A perfect home for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "air-conditioned-townhomes-west-end-allentown-684",
      "search_query": "townhomes with air conditioning West End Allentown",
      "category": "Amenity",
      "h1_title": "Townhomes with Air Conditioning in West End",
      "h2_subtitle": "Experience townhomes with air conditioning in West End Allentown. Enjoy modern amenities and comfortable living at Springhouse Townhomes.",
      "page_copy": "Springhouse Townhomes in the West End of Allentown offers you more than just a home; here, you'll find refreshing townhomes with air conditioning. Our spacious two and three-bedroom designs ensure you stay cool during the hot Pennsylvania summers, allowing you to relax and unwind in comfort. Each townhome features modern amenities, including newly renovated kitchens with granite countertops and track lighting, enhancing your living experience.\n\nBeyond the cool interiors, Springhouse Townhomes provide vibrant community living with pet-friendly amenities such as grilling stations and walking trails. Situated in the lively neighborhood of West End Allentown, our townhomes combine convenience with scenic surroundings. Utilize our online resident portal and flexible rent payments to simplify your lifestyle. Whether savoring the modern interiors or enjoying the outdoor spaces, Springhouse Townhomes offer a perfect blend of comfort and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes with Air Conditioning in West End",
      "seo_description": "Discover townhomes with air conditioning in West End Allentown at Springhouse Townhomes. Enjoy modern amenities and a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "parking-dedicated-apartments-lehigh-county-163",
      "search_query": "apartments with dedicated parking Lehigh County",
      "category": "Amenity",
      "h1_title": "Apartments with Dedicated Parking in Lehigh",
      "h2_subtitle": "Explore apartments with dedicated parking in Lehigh County. At Springhouse Townhomes, enjoy convenience and modern amenities in Allentown, PA.",
      "page_copy": "Springhouse Townhomes offers apartments with dedicated parking in the heart of Lehigh County, ensuring you have a convenient and stylish place to call home. Our spacious two and three-bedroom townhomes come with modern amenities like newly renovated kitchens with granite countertops and track lighting that enhance your daily living. Set in bustling West End Allentown, these townhomes provide the comfort of always having a parking spot waiting upon your return.\n\nBeyond dedicated parking, residents can indulge in a variety of pet-friendly amenities at Springhouse Townhomes, including grilling stations and scenic walking trails. The vibrant community setting adds charm to the already convenient location. With an online resident portal and flexible rent payment options, managing your home life has never been easier. Come enjoy the blend of comfort, style, and convenience at Springhouse Townhomes in beautiful Lehigh County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dedicated Parking in Lehigh",
      "seo_description": "Find apartments with dedicated parking in Lehigh County at Springhouse Townhomes. Enjoy convenience and modern amenities in West End Allentown.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "dishwasher-equipped-townhomes-allentown-18104-955",
      "search_query": "townhomes with dishwasher Allentown 18104",
      "category": "Amenity",
      "h1_title": "Townhomes with Dishwasher in Allentown 18104",
      "h2_subtitle": "Find townhomes with dishwasher in Allentown 18104. Springhouse Townhomes offers modern living with desirable amenities.",
      "page_copy": "Discover the convenience of townhomes with dishwasher in Allentown, 18104, at Springhouse Townhomes. Our spacious two and three-bedroom units come with contemporary features that enhance your daily life, including fully-equipped kitchens boasting granite countertops and dishwashers, making meal prep and clean-up a breeze. Located in the desirable West End neighborhood, living here means enjoying a modern, comfortable lifestyle.\n\nBeyond the in-home amenities, Springhouse Townhomes provide residents with a vibrant community atmosphere. Enjoy pet-friendly communal spaces like grilling stations and lush walking trails. The online resident portal and flexible rent payment options streamline your everyday living, while dedicated parking ensures convenience upon your arrival home. Choose Springhouse Townhomes for a perfect blend of style, convenience, and modern amenities in Allentown, PA 18104.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes with Dishwasher in Allentown 18104",
      "seo_description": "Explore townhomes with dishwasher in Allentown 18104 at Springhouse Townhomes. Enjoy modern living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "renovated-townhomes-inunit-laundry-allentown-539",
      "search_query": "renovated townhomes with in-unit laundry Allentown",
      "category": "Amenity",
      "h1_title": "Renovated Townhomes with In-Unit Laundry",
      "h2_subtitle": "Discover renovated townhomes with in-unit laundry in Allentown. Springhouse Townhomes offers comfort and modern convenience.",
      "page_copy": "At Springhouse Townhomes in Allentown, renovated townhomes with in-unit laundry elevate your everyday living experience. Enjoy the luxury of modern convenience with spacious two and three-bedroom layouts featuring beautifully updated interiors. Our kitchens come equipped with granite countertops and track lighting, providing both style and functionality.\n\nLocated in the vibrant West End of Allentown, these townhomes offer more than just comfort. Embrace a community atmosphere with pet-friendly amenities such as grilling stations and scenic walking trails. Our online resident portal and flexible rent options make managing daily tasks effortless, allowing you to enjoy more of what life has to offer. Choose Springhouse Townhomes for a seamless blend of modern living and convenience in picturesque Allentown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Renovated Townhomes with In-Unit Laundry",
      "seo_description": "Find renovated townhomes with in-unit laundry in Allentown at Springhouse Townhomes. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "three-bedroom-townhomes-west-end-allentown-777",
      "search_query": "three bedroom townhomes west end allentown",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Townhomes in West End Allentown",
      "h2_subtitle": "Explore three bedroom townhomes in West End Allentown. Springhouse Townhomes offers spacious, modern living in a vibrant community.",
      "page_copy": "Discover the spacious three bedroom townhomes in West End Allentown at Springhouse Townhomes. Perfectly suited for those seeking modern comfort, our townhomes feature beautifully renovated kitchens complete with granite countertops and track lighting, providing both style and function in every corner of your home.\n\nLocated in the sought-after West End neighborhood, our community offers a welcoming environment with amenities designed for convenience and enjoyment. Residents benefit from the pet-friendly facilities, including scenic walking trails and grilling stations. Plus, with our online resident portal and flexible rent payment options, managing your home life is streamlined and stress-free. Choose Springhouse Townhomes as your next home for spacious and stylish living in vibrant Allentown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Townhomes in West End Allentown",
      "seo_description": "Find spacious three bedroom townhomes in West End Allentown at Springhouse Townhomes. Enjoy modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "two-bedroom-townhomes-lehigh-county-16",
      "search_query": "two bedroom townhomes lehigh county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Townhomes in Lehigh County",
      "h2_subtitle": "Discover two bedroom townhomes in Lehigh County at Springhouse. Experience modern living with extensive amenities in Allentown.",
      "page_copy": "Welcome to the two bedroom townhomes in Lehigh County at Springhouse Townhomes, a serene oasis offering modern amenities and comfort. Our thoughtfully designed two-bedroom layouts provide ample living space, complemented by upgraded kitchens featuring granite countertops and energy-efficient appliances.\n\nLocated in the thriving West End of Allentown, our community caters to a lifestyle of convenience and leisure. Springhouse Townhomes provides pet-friendly amenities, such as walking trails and grilling stations, perfect for relaxation and socializing. Enjoy the benefits of our online resident portal and flexible rent payment options as you settle into life within Lehigh County's bustling community. Choose Springhouse Townhomes for a perfect balance of comfort, style, and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Townhomes in Lehigh County",
      "seo_description": "Explore two bedroom townhomes in Lehigh County at Springhouse Townhomes. Enjoy modern, comfortable living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "apartments-near-cetronia-elementary-school-245",
      "search_query": "apartments near Cetronia Elementary School Allentown",
      "category": "School",
      "h1_title": "Apartments Near Cetronia Elementary School",
      "h2_subtitle": "Find family-friendly apartments near Cetronia Elementary School. Springhouse Townhomes offer spacious living in a convenient Allentown location.",
      "page_copy": "Springhouse Townhomes offers family-friendly apartments near Cetronia Elementary School in Allentown, ideal for those seeking convenience and comfort in a prime location. Our spacious two and three-bedroom townhomes are equipped with renovated kitchens, including granite countertops, delivering modern style alongside everyday functionality.\n\nLocated in the vibrant West End of Allentown, these townhomes provide a welcoming community with diverse amenities such as pet-friendly walking trails and grilling stations, perfect for family outings or relaxing weekends. With the added convenience of an online resident portal and flexible rent payments, managing family life becomes easier so you can focus on making the most of what Allentown has to offer. Choose Springhouse Townhomes for a comfortable, family-oriented lifestyle near Cetronia Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cetronia Elementary School",
      "seo_description": "Find family-friendly apartments near Cetronia Elementary School at Springhouse Townhomes in Allentown. Spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "springhouse-townhomes-near-muhlenberg-elementary-243",
      "search_query": "Springhouse Townhomes by Muhlenberg Elementary School",
      "category": "School",
      "h1_title": "Springhouse Townhomes by Muhlenberg Elementary",
      "h2_subtitle": "Live at Springhouse Townhomes near Muhlenberg Elementary School. Experience a perfect blend of comfort and accessibility in Allentown.",
      "page_copy": "Welcome to Springhouse Townhomes, conveniently located near Muhlenberg Elementary School. Our community offers the ideal setting for families who prioritize education and comfort. With spacious two and three-bedroom townhomes, you can enjoy modern amenities such as renovated kitchens with elegant granite countertops and energy-efficient fixtures.\n\nSituated in the popular West End neighborhood of Allentown, these townhomes provide easy access to quality schooling and a vibrant community atmosphere. Enjoy pet-friendly amenities including walking trails and grilling stations, perfect for family gatherings or leisurely strolls. The convenience of our online resident portal and flexible rent payment options streamlines daily living, allowing you more time to enjoy the charming surroundings of your new home at Springhouse Townhomes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Springhouse Townhomes by Muhlenberg Elementary",
      "seo_description": "Discover Springhouse Townhomes near Muhlenberg Elementary School. Enjoy modern amenities and spacious living in Allentown's vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "residences-near-francis-d-raub-middle-school-353",
      "search_query": "residences near Francis D. Raub Middle School PA",
      "category": "School",
      "h1_title": "Residences Near Francis D. Raub Middle School",
      "h2_subtitle": "Explore residences near Francis D. Raub Middle School. Springhouse Townhomes provide modern amenities and comfort in Allentown, PA.",
      "page_copy": "Discover your new home at Springhouse Townhomes, offering convenient residences near Francis D. Raub Middle School in Allentown, PA. Our spacious two and three-bedroom townhomes feature upgraded kitchens with elegant granite countertops, designed for practicality and style.\n\nLocated in the desirable West End neighborhood, our community is perfect for families seeking a blend of convenience and comfort. With amenities like pet-friendly walking trails, grilling stations, and an online resident portal, Springhouse Townhomes cater to a vibrant lifestyle. Enjoy flexible rent payments as you settle into one of Allentown's most vibrant areas, where excellent schools like Francis D. Raub Middle School are right at your doorstep. Experience community living that truly meets your needs at Springhouse Townhomes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Francis D. Raub Middle School",
      "seo_description": "Find residences near Francis D. Raub Middle School at Springhouse Townhomes, Allentown, PA. Enjoy spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "west-end-allentown-apartments-near-william-allen-high-school-150",
      "search_query": "West End-Allentown apartments near William Allen High School",
      "category": "School",
      "h1_title": "West End-Allentown Apartments Near William Allen HS",
      "h2_subtitle": "Discover comfortable living in West End-Allentown near William Allen High School. Springhouse Townhomes offers modern amenities and spacious design.",
      "page_copy": "Experience the perfect blend of location and comfort at Springhouse Townhomes, situated in West End-Allentown, near William Allen High School. Our two and three-bedroom townhomes provide a spacious retreat with modern renovations such as granite countertops and stylish track lighting.\n\nLocated in the lively West End neighborhood of Allentown, these townhomes enable convenient access to education and local amenities. With features like pet-friendly walking trails, grilling stations, and an online resident portal, life at Springhouse Townhomes is both convenient and enriching. Enjoy flexible rent payments and a community atmosphere where quality schooling is just around the corner. Your next home, filled with possibilities and convenience, awaits at Springhouse Townhomes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "West End-Allentown Apartments Near William Allen HS",
      "seo_description": "Find apartments in West End-Allentown near William Allen High School. Experience modern amenities and spacious living at Springhouse Townhomes.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "lehigh-county-apartments-near-parkland-high-school-723",
      "search_query": "Lehigh County apartments close to Parkland High School",
      "category": "School",
      "h1_title": "Lehigh County Apartments Near Parkland High School",
      "h2_subtitle": "Discover Lehigh County apartments close to Parkland High School. Springhouse Townhomes offers a perfect blend of comfort and convenience.",
      "page_copy": "Welcome to Springhouse Townhomes, where modern living meets prime location in Lehigh County, close to Parkland High School. Our spacious two and three-bedroom apartments are designed with contemporary features, including newly renovated kitchens with granite countertops and efficient track lighting.\n\nSituated in Allentown's vibrant West End neighborhood, Springhouse Townhomes ensures easy access to one of the best schools in the area and a host of local amenities. Experience the convenience of pet-friendly walking trails, outdoor grilling stations, and an online resident portal. With flexible rent payment options, these townhomes are perfect for families and individuals seeking comfort and lifestyle. Find your new home in Lehigh County where top-notch education and modern living come together.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lehigh County Apartments Near Parkland High School",
      "seo_description": "Explore spacious Lehigh County apartments near Parkland High School at Springhouse Townhomes. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "rental-homes-by-springhouse-middle-school-18104-21",
      "search_query": "rental homes by Springhouse Middle School 18104",
      "category": "School",
      "h1_title": "Rental Homes by Springhouse Middle School 18104",
      "h2_subtitle": "Discover rental homes near Springhouse Middle School in 18104. Springhouse Townhomes offers modern amenities and a vibrant community.",
      "page_copy": "Explore the ideal setting for your family at Springhouse Townhomes, offering rental homes by Springhouse Middle School in the 18104 area. Our beautifully designed two and three-bedroom townhomes feature upgraded kitchens with granite countertops and stylish track lighting, creating a welcoming atmosphere.\n\nLocated conveniently in Allentown's West End, these homes provide immediate access to top educational institutions and neighborhood amenities. Embrace a community lifestyle with pet-friendly trails, grilling stations, and the ease of an online resident portal. Opt for our flexible rent payment options and immerse yourself in a vibrant environment where quality schooling and modern living are seamlessly integrated. Make Springhouse Townhomes your new home, right around the corner from Springhouse Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes by Springhouse Middle School 18104",
      "seo_description": "Find rental homes near Springhouse Middle School in 18104 at Springhouse Townhomes. Enjoy modern amenities and spacious living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "apartment-living-near-cedar-crest-college-pa-118",
      "search_query": "apartment living near Cedar Crest College PA",
      "category": "School",
      "h1_title": "Apartment Living Near Cedar Crest College PA",
      "h2_subtitle": "Explore apartment living near Cedar Crest College in PA. Springhouse Townhomes offers comfort and convenience in a vibrant community.",
      "page_copy": "Discover the exceptional apartment living experience at Springhouse Townhomes, conveniently located near Cedar Crest College in Allentown, PA. Our spacious two and three-bedroom townhomes feature modern upgrades like granite countertops and efficient track lighting, offering a perfect blend of style and comfort.\n\nEnjoy the benefits of living in Allentown's bustling West End neighborhood, just a short distance from Cedar Crest College. Our community is designed with residents in mind, featuring pet-friendly walking trails, grilling stations, and an intuitive online resident portal. With flexible rent payments and a welcoming environment, Springhouse Townhomes provides an ideal home base for college students and professionals alike seeking proximity to education and vibrant city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Cedar Crest College PA",
      "seo_description": "Experience apartment living near Cedar Crest College in PA at Springhouse Townhomes, offering comfort and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "muhlenberg-college-nearby-springhouse-townhomes-651",
      "search_query": "Muhlenberg College nearby Springhouse Townhomes",
      "category": "School",
      "h1_title": "Muhlenberg College Nearby Springhouse Townhomes",
      "h2_subtitle": "Discover the ease of living near Muhlenberg College at Springhouse Townhomes. Enjoy modern townhomes in a vibrant community.",
      "page_copy": "Springhouse Townhomes offers ideal living for those seeking proximity to Muhlenberg College in Allentown, PA. Our spacious two and three-bedroom townhomes are equipped with modern amenities like granite countertops and stylish track lighting, ensuring a comfortable and contemporary living experience.\n\nPositioned in the dynamic West End of Allentown, Springhouse Townhomes provides easy access to Muhlenberg College and the surrounding community amenities. Enjoy pet-friendly walking trails, outdoor grilling spaces, and an online resident portal, all designed to enhance your lifestyle. With flexible rent payment options, Springhouse Townhomes offers a perfect combination of location and modern living for students and professionals desiring quality housing close to campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Muhlenberg College Nearby Springhouse Townhomes",
      "seo_description": "Live near Muhlenberg College at Springhouse Townhomes. Experience modern amenities and convenient living in a prime Allentown location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "townhomes-near-lehigh-valley-hospital-cedar-crest-allentown-28",
      "search_query": "townhomes near Lehigh Valley Hospital Cedar Crest Allentown",
      "category": "Hospital",
      "h1_title": "Townhomes Near Lehigh Valley Hospital Cedar Crest",
      "h2_subtitle": "Find townhomes near Lehigh Valley Hospital Cedar Crest in Allentown. Springhouse Townhomes offers convenience and modern amenities nearby.",
      "page_copy": "Springhouse Townhomes presents a unique opportunity for those seeking townhomes near Lehigh Valley Hospital Cedar Crest in Allentown, PA. Our community features spacious two and three-bedroom layouts complete with upgraded kitchens boasting granite countertops and stylish track lighting, offering a blend of sophistication and functionality.\n\nConveniently located in Allentown's West End, Springhouse Townhomes places you just moments from the hospital while providing access to vibrant local amenities. Enjoy the comfort of pet-friendly walking trails, outdoor grilling stations, and the ease of an online resident portal. With flexible payment options, living near Lehigh Valley Hospital Cedar Crest has never been more accommodating or stylish. Join our community and experience the perfect balance of location and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Lehigh Valley Hospital Cedar Crest",
      "seo_description": "Discover Springhouse Townhomes near Lehigh Valley Hospital Cedar Crest. Experience convenience and modern amenities in Allentown.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "apartments-close-to-st-lukes-hospital-allentown-campus-pa-715",
      "search_query": "apartments close to St. Luke's Hospital Allentown Campus PA",
      "category": "Hospital",
      "h1_title": "Apartments Close to St. Luke's Hospital Allentown",
      "h2_subtitle": "Live in stylish apartments close to St. Luke's Hospital Allentown Campus. Enjoy modern comfort at Springhouse Townhomes.",
      "page_copy": "Springhouse Townhomes offers an ideal location for those seeking apartments close to St. Luke's Hospital Allentown Campus. Nestled in a lively part of Allentown, PA, our two and three-bedroom townhomes are designed for modern living, featuring renovated kitchens with granite countertops and trendy track lighting.\n\nExperience the benefits of living just minutes from St. Luke's Hospital while enjoying the serene surroundings of West End Allentown. Our community is perfect for busy professionals and families, offering pet-friendly amenities like walking trails, convenient grilling stations, and a seamless online resident portal. With flexible rent payment options, Springhouse Townhomes provides a stress-free living experience close to healthcare services and vibrant city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to St. Luke's Hospital Allentown",
      "seo_description": "Springhouse Townhomes offers stylish living close to St. Luke's Hospital Allentown Campus. Enjoy modern, convenient amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "apartments-near-trexler-memorial-park-allentown-890",
      "search_query": "apartments near Trexler Memorial Park Allentown",
      "category": "Park",
      "h1_title": "Apartments Near Trexler Memorial Park",
      "h2_subtitle": "Discover apartments near Trexler Memorial Park in Allentown at Springhouse Townhomes. Enjoy spacious living with scenic views.",
      "page_copy": "At Springhouse Townhomes, residents can experience the perfect blend of urban convenience and natural beauty by living in apartments near Trexler Memorial Park in Allentown. We offer spacious two and three-bedroom designs, each featuring modern amenities like renovated kitchens with granite countertops and elegant track lighting, perfect for a contemporary lifestyle.\n\nSituated in Allentown's lively West End, Springhouse Townhomes provides easy access to the lush landscapes of Trexler Memorial Park while delivering comfort and convenience. Our community is pet-friendly, with amenities such as walking trails, grilling stations, and an online resident portal designed to elevate your living experience. Enjoy the flexibility of rent payments and become part of a vibrant neighborhood embracing both relaxation and activity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Trexler Memorial Park Allentown",
      "seo_description": "Live near Trexler Memorial Park at Springhouse Townhomes. Discover modern, spacious residences with convenient access to nature and city amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "townhomes-near-cedar-beach-park-west-end-allentown-729",
      "search_query": "townhomes near Cedar Beach Park West End-Allentown",
      "category": "Park",
      "h1_title": "Townhomes Near Cedar Beach Park, West End",
      "h2_subtitle": "Explore townhomes near Cedar Beach Park in West End Allentown. Springhouse Townhomes offers spacious living close to nature.",
      "page_copy": "Springhouse Townhomes is your gateway to serene living with easy access to Cedar Beach Park in the vibrant neighborhood of West End-Allentown. Our community features elegantly designed two and three-bedroom townhomes, complete with modern kitchens adorned with granite countertops and stylish track lighting, perfect for anyone looking to combine comfort with contemporary style.\n\nLocated near the scenic Cedar Beach Park, our townhomes provide a convenient and picturesque living experience. Residents can enjoy pet-friendly amenities such as walking trails, outdoor grilling areas, and an online resident portal that simplifies daily living. With flexible rent options available, Springhouse Townhomes offers not just a place to live, but a lifestyle destination in West End-Allentown, balancing urban amenities with the tranquility of nearby natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Cedar Beach Park, West End Allentown",
      "seo_description": "Discover Springhouse Townhomes near Cedar Beach Park in West End Allentown. Enjoy spacious living in a beautiful, convenient setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "homes-close-to-malcolm-gross-rose-garden-pa-15",
      "search_query": "homes close to Malcolm Gross Rose Garden PA",
      "category": "Park",
      "h1_title": "Homes Close to Malcolm Gross Rose Garden",
      "h2_subtitle": "Find homes close to Malcolm Gross Rose Garden in PA at Springhouse Townhomes. Enjoy a blend of modern comforts and natural beauty.",
      "page_copy": "Located in Allentown, PA, Springhouse Townhomes presents the ideal choice for those seeking homes close to Malcolm Gross Rose Garden. Our spacious two and three-bedroom townhomes are tailored for comfort and convenience, featuring modern amenities such as renovated kitchens with granite countertops and chic track lighting, ensuring a sophisticated living experience.\n\nEmbrace the beauty of Malcolm Gross Rose Garden while enjoying the lifestyle and amenities offered at Springhouse Townhomes. The property provides pet-friendly features, including walking trails and grilling stations, perfect for leisure and relaxation. An online resident portal and flexible rent payment options add to the convenience, making it easy to enjoy life within this vibrant and scenic community, just steps away from one of Allentown's most beloved gardens.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homes Close to Malcolm Gross Rose Garden PA",
      "seo_description": "Live at Springhouse Townhomes close to Malcolm Gross Rose Garden PA. Enjoy modern amenities and beautiful surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "living-near-lehigh-parkway-lehigh-county-150",
      "search_query": "living near Lehigh Parkway Lehigh County",
      "category": "Park",
      "h1_title": "Living Near Lehigh Parkway",
      "h2_subtitle": "Enjoy living near Lehigh Parkway in Lehigh County with Springhouse Townhomes offering modern comfort and scenic beauty.",
      "page_copy": "For those seeking a prime location in Lehigh County, Springhouse Townhomes offers an exceptional opportunity for living near Lehigh Parkway. Our community provides spacious two and three-bedroom townhomes with amenities designed for modern living, including upgraded kitchens with granite countertops and elegant track lighting.\n\nNestled in a serene setting, Springhouse Townhomes combines comfort and convenience with the natural beauty of nearby Lehigh Parkway. Residents can fully enjoy pet-friendly amenities such as walking trails and outdoor grilling spaces. Our online resident portal and flexible rent payment options further enhance the living experience, making Springhouse Townhomes an ideal choice for those desiring a balanced lifestyle close to nature in Lehigh County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Lehigh Parkway Lehigh County",
      "seo_description": "Discover Springhouse Townhomes for living near Lehigh Parkway, Lehigh County. Enjoy modern homes with natural and urban conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "rentals-near-jordan-creek-parkway-allentown-18104-993",
      "search_query": "rentals near Jordan Creek Parkway Allentown 18104",
      "category": "Park",
      "h1_title": "Rentals Near Jordan Creek Parkway, Allentown",
      "h2_subtitle": "Discover rentals near Jordan Creek Parkway in Allentown, 18104. Springhouse Townhomes offers comfort and convenience in a beautiful setting.",
      "page_copy": "Springhouse Townhomes offers an ideal location for those looking for rentals near Jordan Creek Parkway in Allentown, 18104. Our community features spacious two and three-bedroom townhomes designed with modern amenities, including renovated kitchens with granite countertops and stylish track lighting, ensuring a comfortable lifestyle.\n\nLocated in scenic Allentown, our pet-friendly community provides walking trails and grilling stations, perfect for enjoying the outdoors. With an online resident portal and flexible rent payment options, Springhouse Townhomes makes living near Jordan Creek Parkway effortless and enjoyable. Experience the perfect blend of urban convenience and natural beauty in one of Allentown's most coveted areas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Jordan Creek Parkway, Allentown 18104",
      "seo_description": "Find rentals near Jordan Creek Parkway in Allentown 18104 at Springhouse Townhomes. Modern living with convenient amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166344",
      "source": "custom",
      "page_item_url": "apartments-near-lehigh-valley-airport-allentown-pa-178",
      "search_query": "apartments near Lehigh Valley International Airport Allentown PA",
      "category": "Transit",
      "h1_title": "Apartments Near Lehigh Valley Airport",
      "h2_subtitle": "Explore apartments near Lehigh Valley International Airport in Allentown, PA at Springhouse Townhomes. Comfort meets convenience in a prime location.",
      "page_copy": "Springhouse Townhomes provides an excellent choice for those seeking apartments near Lehigh Valley International Airport in Allentown, PA. Our spacious two and three-bedroom townhomes are equipped with modern amenities that cater to a comfortable lifestyle, including renovated kitchens with granite countertops and chic track lighting.\n\nPerfectly positioned in Allentown, our community offers the convenience of being close to the airport while providing residents with access to beautiful walking trails and pet-friendly amenities. Enjoy the flexibility of an online resident portal and convenient rent payment options. Experience the blend of modern living and accessibility, making Springhouse Townhomes the ideal place for those frequently traveling or desiring swift access to the vibrant urban offerings of the area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhome exteriors with garages, manicured landscaping, and a large shopping center with a parking lot in the background.",
        "public_id": "019fce09-6f3a-721c-b859-f5a785bfedb3",
        "storage_key": "property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp",
        "width": 3072,
        "height": 1728
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lehigh Valley Airport, Allentown PA",
      "seo_description": "Discover modern living at Springhouse Townhomes, apartments near Lehigh Valley International Airport, Allentown PA. Experience convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5081"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976282068"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4993353"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PLQJLSR5"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://springhousetownhomes.fatwin.com/api/websites/resources/1?x=QlY2RFpSbVVGZVlUU2lnMlVMcTc1Y0VsVTJZdFNsVkVJRXp6NmVKZFFRSGZiR1QwN0x3bW5GQ2FoOEJlNUVKUElLanIxZXJaWHlXZDVaRitHL29uaEE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9547a2ec-43e6-11ef-85de-ebbe0e64e54a"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547a2ec-43e6-11ef-85de-ebbe0e64e54a/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547a2ec-43e6-11ef-85de-ebbe0e64e54a/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im1mY2hST2FZWWZYaTgwdFdnck91alE9PSIsInZhbHVlIjoiUlI5WmRXbGFTTjZkSHNnSm5sTWEvZz09IiwibWFjIjoiZGMwNTFhMjBkNmJmN2YxZjdlNzE3N2FhYWNkOTQ4ZDBiZmQyYzkwOWMzZDBjNjE0OGZhMjIwZGY4ZDQyNWY0ZiJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5081",
  "custom_repli_id": "9976282068",
  "custom_realpage_id": "4993353",
  "custom_google_gtm_id": "GTM-PLQJLSR5",
  "custom_perq_script_url": "https://springhousetownhomes.fatwin.com/api/websites/resources/1?x=QlY2RFpSbVVGZVlUU2lnMlVMcTc1Y0VsVTJZdFNsVkVJRXp6NmVKZFFRSGZiR1QwN0x3bW5GQ2FoOEJlNUVKUElLanIxZXJaWHlXZDVaRitHL29uaEE9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9547a2ec-43e6-11ef-85de-ebbe0e64e54a",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547a2ec-43e6-11ef-85de-ebbe0e64e54a/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547a2ec-43e6-11ef-85de-ebbe0e64e54a/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im1mY2hST2FZWWZYaTgwdFdnck91alE9PSIsInZhbHVlIjoiUlI5WmRXbGFTTjZkSHNnSm5sTWEvZz09IiwibWFjIjoiZGMwNTFhMjBkNmJmN2YxZjdlNzE3N2FhYWNkOTQ4ZDBiZmQyYzkwOWMzZDBjNjE0OGZhMjIwZGY4ZDQyNWY0ZiJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "188641f7-af26-4705-935e-666cedccf2bb",
  "custom_audioeye_site_hash": "15f7ae7f1dbf8c98d0d541fae3409be7"
};

export const generatedAt = '2026-10-22T20:05:53.574Z';
